/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TeamsIndexRouteImport } from './routes/teams/index'
import { Route as SubscriptionIndexRouteImport } from './routes/subscription/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as CompaniesIndexRouteImport } from './routes/companies/index'
import { Route as TeamsAcceptRouteImport } from './routes/teams/accept'
import { Route as TeamsTeamIdRouteImport } from './routes/teams/$teamId'
import { Route as SettingsTokensRouteImport } from './routes/settings/tokens'
import { Route as CompaniesNewRouteImport } from './routes/companies/new'
import { Route as CompaniesCompanyIdRouteImport } from './routes/companies/$companyId'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as CompaniesCompanyIdIndexRouteImport } from './routes/companies/$companyId.index'
import { Route as InviteDeclineTokenRouteImport } from './routes/invite.decline.$token'
import { Route as InviteAcceptTokenRouteImport } from './routes/invite.accept.$token'
import { Route as CompaniesCompanyIdEditRouteImport } from './routes/companies/$companyId.edit'
import { Route as CompaniesCompanyIdBancosRouteImport } from './routes/companies/$companyId.bancos'
import { Route as CompaniesCompanyIdTercerosIndexRouteImport } from './routes/companies/$companyId.terceros.index'
import { Route as CompaniesCompanyIdResolucionesIndexRouteImport } from './routes/companies/$companyId.resoluciones.index'
import { Route as CompaniesCompanyIdReportesIndexRouteImport } from './routes/companies/$companyId.reportes.index'
import { Route as CompaniesCompanyIdRecibosIndexRouteImport } from './routes/companies/$companyId.recibos.index'
import { Route as CompaniesCompanyIdRecibidasIndexRouteImport } from './routes/companies/$companyId.recibidas.index'
import { Route as CompaniesCompanyIdPucIndexRouteImport } from './routes/companies/$companyId.puc.index'
import { Route as CompaniesCompanyIdProductosIndexRouteImport } from './routes/companies/$companyId.productos.index'
import { Route as CompaniesCompanyIdPosIndexRouteImport } from './routes/companies/$companyId.pos.index'
import { Route as CompaniesCompanyIdNotasDebitoIndexRouteImport } from './routes/companies/$companyId.notas-debito.index'
import { Route as CompaniesCompanyIdNotasCreditoIndexRouteImport } from './routes/companies/$companyId.notas-credito.index'
import { Route as CompaniesCompanyIdNominaIndexRouteImport } from './routes/companies/$companyId.nomina.index'
import { Route as CompaniesCompanyIdInventarioIndexRouteImport } from './routes/companies/$companyId.inventario.index'
import { Route as CompaniesCompanyIdImpuestosIndexRouteImport } from './routes/companies/$companyId.impuestos.index'
import { Route as CompaniesCompanyIdImportacionesIndexRouteImport } from './routes/companies/$companyId.importaciones.index'
import { Route as CompaniesCompanyIdFacturasIndexRouteImport } from './routes/companies/$companyId.facturas.index'
import { Route as CompaniesCompanyIdEgresosIndexRouteImport } from './routes/companies/$companyId.egresos.index'
import { Route as CompaniesCompanyIdDocumentosSoporteIndexRouteImport } from './routes/companies/$companyId.documentos-soporte.index'
import { Route as CompaniesCompanyIdContabilidadIndexRouteImport } from './routes/companies/$companyId.contabilidad.index'
import { Route as CompaniesCompanyIdComprasIndexRouteImport } from './routes/companies/$companyId.compras.index'
import { Route as CompaniesCompanyIdCarteraIndexRouteImport } from './routes/companies/$companyId.cartera.index'
import { Route as CompaniesCompanyIdArchivosIndexRouteImport } from './routes/companies/$companyId.archivos.index'
import { Route as CompaniesCompanyIdTercerosNewRouteImport } from './routes/companies/$companyId.terceros.new'
import { Route as CompaniesCompanyIdTercerosTerceroIdRouteImport } from './routes/companies/$companyId.terceros.$terceroId'
import { Route as CompaniesCompanyIdReportesRetencionesRouteImport } from './routes/companies/$companyId.reportes.retenciones'
import { Route as CompaniesCompanyIdReportesIvaRouteImport } from './routes/companies/$companyId.reportes.iva'
import { Route as CompaniesCompanyIdReportesEstadoResultadosRouteImport } from './routes/companies/$companyId.reportes.estado-resultados'
import { Route as CompaniesCompanyIdReportesBalanceGeneralRouteImport } from './routes/companies/$companyId.reportes.balance-general'
import { Route as CompaniesCompanyIdRecibosNewRouteImport } from './routes/companies/$companyId.recibos.new'
import { Route as CompaniesCompanyIdRecibosReceiptIdRouteImport } from './routes/companies/$companyId.recibos.$receiptId'
import { Route as CompaniesCompanyIdRecibidasBuzonRouteImport } from './routes/companies/$companyId.recibidas.buzon'
import { Route as CompaniesCompanyIdRecibidasReceivedIdRouteImport } from './routes/companies/$companyId.recibidas.$receivedId'
import { Route as CompaniesCompanyIdProductosNewRouteImport } from './routes/companies/$companyId.productos.new'
import { Route as CompaniesCompanyIdProductosProductIdRouteImport } from './routes/companies/$companyId.productos.$productId'
import { Route as CompaniesCompanyIdPosNewRouteImport } from './routes/companies/$companyId.pos.new'
import { Route as CompaniesCompanyIdPosDocumentIdRouteImport } from './routes/companies/$companyId.pos.$documentId'
import { Route as CompaniesCompanyIdNotasDebitoNewRouteImport } from './routes/companies/$companyId.notas-debito.new'
import { Route as CompaniesCompanyIdNotasDebitoNoteIdRouteImport } from './routes/companies/$companyId.notas-debito.$noteId'
import { Route as CompaniesCompanyIdNotasCreditoNewRouteImport } from './routes/companies/$companyId.notas-credito.new'
import { Route as CompaniesCompanyIdInventarioReportesRouteImport } from './routes/companies/$companyId.inventario.reportes'
import { Route as CompaniesCompanyIdInventarioBodegasRouteImport } from './routes/companies/$companyId.inventario.bodegas'
import { Route as CompaniesCompanyIdImpuestosConfiguracionRouteImport } from './routes/companies/$companyId.impuestos.configuracion'
import { Route as CompaniesCompanyIdImpuestosEventIdRouteImport } from './routes/companies/$companyId.impuestos.$eventId'
import { Route as CompaniesCompanyIdFacturasNewRouteImport } from './routes/companies/$companyId.facturas.new'
import { Route as CompaniesCompanyIdEgresosNewRouteImport } from './routes/companies/$companyId.egresos.new'
import { Route as CompaniesCompanyIdEgresosVoucherIdRouteImport } from './routes/companies/$companyId.egresos.$voucherId'
import { Route as CompaniesCompanyIdDocumentosSoporteNewRouteImport } from './routes/companies/$companyId.documentos-soporte.new'
import { Route as CompaniesCompanyIdDocumentosSoporteDocumentIdRouteImport } from './routes/companies/$companyId.documentos-soporte.$documentId'
import { Route as CompaniesCompanyIdContabilidadSaldosInicialesRouteImport } from './routes/companies/$companyId.contabilidad.saldos-iniciales'
import { Route as CompaniesCompanyIdContabilidadCuentasRouteImport } from './routes/companies/$companyId.contabilidad.cuentas'
import { Route as CompaniesCompanyIdComprasNewRouteImport } from './routes/companies/$companyId.compras.new'
import { Route as CompaniesCompanyIdComprasInvoiceIdRouteImport } from './routes/companies/$companyId.compras.$invoiceId'
import { Route as CompaniesCompanyIdCarteraTerceroIdRouteImport } from './routes/companies/$companyId.cartera.$terceroId'
import { Route as CompaniesCompanyIdPosAjustesIndexRouteImport } from './routes/companies/$companyId.pos.ajustes.index'
import { Route as CompaniesCompanyIdNotasCreditoNoteIdIndexRouteImport } from './routes/companies/$companyId.notas-credito.$noteId.index'
import { Route as CompaniesCompanyIdNominaPayslipsIndexRouteImport } from './routes/companies/$companyId.nomina.payslips.index'
import { Route as CompaniesCompanyIdNominaLiquidacionesIndexRouteImport } from './routes/companies/$companyId.nomina.liquidaciones.index'
import { Route as CompaniesCompanyIdNominaEmpleadosIndexRouteImport } from './routes/companies/$companyId.nomina.empleados.index'
import { Route as CompaniesCompanyIdNominaDefinitivasIndexRouteImport } from './routes/companies/$companyId.nomina.definitivas.index'
import { Route as CompaniesCompanyIdNominaAjustesIndexRouteImport } from './routes/companies/$companyId.nomina.ajustes.index'
import { Route as CompaniesCompanyIdInventarioMovimientosIndexRouteImport } from './routes/companies/$companyId.inventario.movimientos.index'
import { Route as CompaniesCompanyIdInventarioConteosIndexRouteImport } from './routes/companies/$companyId.inventario.conteos.index'
import { Route as CompaniesCompanyIdFacturasInvoiceIdIndexRouteImport } from './routes/companies/$companyId.facturas.$invoiceId.index'
import { Route as CompaniesCompanyIdContabilidadMayorIndexRouteImport } from './routes/companies/$companyId.contabilidad.mayor.index'
import { Route as CompaniesCompanyIdContabilidadDiarioIndexRouteImport } from './routes/companies/$companyId.contabilidad.diario.index'
import { Route as CompaniesCompanyIdPosAjustesNewRouteImport } from './routes/companies/$companyId.pos.ajustes.new'
import { Route as CompaniesCompanyIdPosAjustesAdjustmentIdRouteImport } from './routes/companies/$companyId.pos.ajustes.$adjustmentId'
import { Route as CompaniesCompanyIdNotasCreditoNoteIdPreviewRouteImport } from './routes/companies/$companyId.notas-credito.$noteId.preview'
import { Route as CompaniesCompanyIdNominaPayslipsNewRouteImport } from './routes/companies/$companyId.nomina.payslips.new'
import { Route as CompaniesCompanyIdNominaPayslipsPayslipIdRouteImport } from './routes/companies/$companyId.nomina.payslips.$payslipId'
import { Route as CompaniesCompanyIdNominaLiquidacionesNewRouteImport } from './routes/companies/$companyId.nomina.liquidaciones.new'
import { Route as CompaniesCompanyIdNominaLiquidacionesLiquidationIdRouteImport } from './routes/companies/$companyId.nomina.liquidaciones.$liquidationId'
import { Route as CompaniesCompanyIdNominaEmpleadosNewRouteImport } from './routes/companies/$companyId.nomina.empleados.new'
import { Route as CompaniesCompanyIdNominaEmpleadosEmployeeIdRouteImport } from './routes/companies/$companyId.nomina.empleados.$employeeId'
import { Route as CompaniesCompanyIdNominaDefinitivasNewRouteImport } from './routes/companies/$companyId.nomina.definitivas.new'
import { Route as CompaniesCompanyIdNominaDefinitivasSettlementIdRouteImport } from './routes/companies/$companyId.nomina.definitivas.$settlementId'
import { Route as CompaniesCompanyIdNominaAjustesNewRouteImport } from './routes/companies/$companyId.nomina.ajustes.new'
import { Route as CompaniesCompanyIdNominaAjustesAdjustmentIdRouteImport } from './routes/companies/$companyId.nomina.ajustes.$adjustmentId'
import { Route as CompaniesCompanyIdInventarioTrasladosNewRouteImport } from './routes/companies/$companyId.inventario.traslados.new'
import { Route as CompaniesCompanyIdInventarioMovimientosNewRouteImport } from './routes/companies/$companyId.inventario.movimientos.new'
import { Route as CompaniesCompanyIdInventarioConteosCountIdRouteImport } from './routes/companies/$companyId.inventario.conteos.$countId'
import { Route as CompaniesCompanyIdFacturasInvoiceIdPreviewRouteImport } from './routes/companies/$companyId.facturas.$invoiceId.preview'
import { Route as CompaniesCompanyIdContabilidadMayorAccountCodeRouteImport } from './routes/companies/$companyId.contabilidad.mayor.$accountCode'
import { Route as CompaniesCompanyIdContabilidadDiarioNuevoRouteImport } from './routes/companies/$companyId.contabilidad.diario.nuevo'
import { Route as CompaniesCompanyIdContabilidadDiarioEntryIdRouteImport } from './routes/companies/$companyId.contabilidad.diario.$entryId'

const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamsIndexRoute = TeamsIndexRouteImport.update({
  id: '/teams/',
  path: '/teams/',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscriptionIndexRoute = SubscriptionIndexRouteImport.update({
  id: '/subscription/',
  path: '/subscription/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const CompaniesIndexRoute = CompaniesIndexRouteImport.update({
  id: '/companies/',
  path: '/companies/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamsAcceptRoute = TeamsAcceptRouteImport.update({
  id: '/teams/accept',
  path: '/teams/accept',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamsTeamIdRoute = TeamsTeamIdRouteImport.update({
  id: '/teams/$teamId',
  path: '/teams/$teamId',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsTokensRoute = SettingsTokensRouteImport.update({
  id: '/settings/tokens',
  path: '/settings/tokens',
  getParentRoute: () => rootRouteImport,
} as any)
const CompaniesNewRoute = CompaniesNewRouteImport.update({
  id: '/companies/new',
  path: '/companies/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CompaniesCompanyIdRoute = CompaniesCompanyIdRouteImport.update({
  id: '/companies/$companyId',
  path: '/companies/$companyId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const CompaniesCompanyIdIndexRoute = CompaniesCompanyIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CompaniesCompanyIdRoute,
} as any)
const InviteDeclineTokenRoute = InviteDeclineTokenRouteImport.update({
  id: '/invite/decline/$token',
  path: '/invite/decline/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteAcceptTokenRoute = InviteAcceptTokenRouteImport.update({
  id: '/invite/accept/$token',
  path: '/invite/accept/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const CompaniesCompanyIdEditRoute = CompaniesCompanyIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => CompaniesCompanyIdRoute,
} as any)
const CompaniesCompanyIdBancosRoute =
  CompaniesCompanyIdBancosRouteImport.update({
    id: '/bancos',
    path: '/bancos',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdTercerosIndexRoute =
  CompaniesCompanyIdTercerosIndexRouteImport.update({
    id: '/terceros/',
    path: '/terceros/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdResolucionesIndexRoute =
  CompaniesCompanyIdResolucionesIndexRouteImport.update({
    id: '/resoluciones/',
    path: '/resoluciones/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdReportesIndexRoute =
  CompaniesCompanyIdReportesIndexRouteImport.update({
    id: '/reportes/',
    path: '/reportes/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdRecibosIndexRoute =
  CompaniesCompanyIdRecibosIndexRouteImport.update({
    id: '/recibos/',
    path: '/recibos/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdRecibidasIndexRoute =
  CompaniesCompanyIdRecibidasIndexRouteImport.update({
    id: '/recibidas/',
    path: '/recibidas/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdPucIndexRoute =
  CompaniesCompanyIdPucIndexRouteImport.update({
    id: '/puc/',
    path: '/puc/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdProductosIndexRoute =
  CompaniesCompanyIdProductosIndexRouteImport.update({
    id: '/productos/',
    path: '/productos/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdPosIndexRoute =
  CompaniesCompanyIdPosIndexRouteImport.update({
    id: '/pos/',
    path: '/pos/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdNotasDebitoIndexRoute =
  CompaniesCompanyIdNotasDebitoIndexRouteImport.update({
    id: '/notas-debito/',
    path: '/notas-debito/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdNotasCreditoIndexRoute =
  CompaniesCompanyIdNotasCreditoIndexRouteImport.update({
    id: '/notas-credito/',
    path: '/notas-credito/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdNominaIndexRoute =
  CompaniesCompanyIdNominaIndexRouteImport.update({
    id: '/nomina/',
    path: '/nomina/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdInventarioIndexRoute =
  CompaniesCompanyIdInventarioIndexRouteImport.update({
    id: '/inventario/',
    path: '/inventario/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdImpuestosIndexRoute =
  CompaniesCompanyIdImpuestosIndexRouteImport.update({
    id: '/impuestos/',
    path: '/impuestos/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdImportacionesIndexRoute =
  CompaniesCompanyIdImportacionesIndexRouteImport.update({
    id: '/importaciones/',
    path: '/importaciones/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdFacturasIndexRoute =
  CompaniesCompanyIdFacturasIndexRouteImport.update({
    id: '/facturas/',
    path: '/facturas/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdEgresosIndexRoute =
  CompaniesCompanyIdEgresosIndexRouteImport.update({
    id: '/egresos/',
    path: '/egresos/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdDocumentosSoporteIndexRoute =
  CompaniesCompanyIdDocumentosSoporteIndexRouteImport.update({
    id: '/documentos-soporte/',
    path: '/documentos-soporte/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdContabilidadIndexRoute =
  CompaniesCompanyIdContabilidadIndexRouteImport.update({
    id: '/contabilidad/',
    path: '/contabilidad/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdComprasIndexRoute =
  CompaniesCompanyIdComprasIndexRouteImport.update({
    id: '/compras/',
    path: '/compras/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdCarteraIndexRoute =
  CompaniesCompanyIdCarteraIndexRouteImport.update({
    id: '/cartera/',
    path: '/cartera/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdArchivosIndexRoute =
  CompaniesCompanyIdArchivosIndexRouteImport.update({
    id: '/archivos/',
    path: '/archivos/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdTercerosNewRoute =
  CompaniesCompanyIdTercerosNewRouteImport.update({
    id: '/terceros/new',
    path: '/terceros/new',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdTercerosTerceroIdRoute =
  CompaniesCompanyIdTercerosTerceroIdRouteImport.update({
    id: '/terceros/$terceroId',
    path: '/terceros/$terceroId',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdReportesRetencionesRoute =
  CompaniesCompanyIdReportesRetencionesRouteImport.update({
    id: '/reportes/retenciones',
    path: '/reportes/retenciones',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdReportesIvaRoute =
  CompaniesCompanyIdReportesIvaRouteImport.update({
    id: '/reportes/iva',
    path: '/reportes/iva',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdReportesEstadoResultadosRoute =
  CompaniesCompanyIdReportesEstadoResultadosRouteImport.update({
    id: '/reportes/estado-resultados',
    path: '/reportes/estado-resultados',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdReportesBalanceGeneralRoute =
  CompaniesCompanyIdReportesBalanceGeneralRouteImport.update({
    id: '/reportes/balance-general',
    path: '/reportes/balance-general',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdRecibosNewRoute =
  CompaniesCompanyIdRecibosNewRouteImport.update({
    id: '/recibos/new',
    path: '/recibos/new',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdRecibosReceiptIdRoute =
  CompaniesCompanyIdRecibosReceiptIdRouteImport.update({
    id: '/recibos/$receiptId',
    path: '/recibos/$receiptId',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdRecibidasBuzonRoute =
  CompaniesCompanyIdRecibidasBuzonRouteImport.update({
    id: '/recibidas/buzon',
    path: '/recibidas/buzon',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdRecibidasReceivedIdRoute =
  CompaniesCompanyIdRecibidasReceivedIdRouteImport.update({
    id: '/recibidas/$receivedId',
    path: '/recibidas/$receivedId',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdProductosNewRoute =
  CompaniesCompanyIdProductosNewRouteImport.update({
    id: '/productos/new',
    path: '/productos/new',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdProductosProductIdRoute =
  CompaniesCompanyIdProductosProductIdRouteImport.update({
    id: '/productos/$productId',
    path: '/productos/$productId',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdPosNewRoute =
  CompaniesCompanyIdPosNewRouteImport.update({
    id: '/pos/new',
    path: '/pos/new',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdPosDocumentIdRoute =
  CompaniesCompanyIdPosDocumentIdRouteImport.update({
    id: '/pos/$documentId',
    path: '/pos/$documentId',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdNotasDebitoNewRoute =
  CompaniesCompanyIdNotasDebitoNewRouteImport.update({
    id: '/notas-debito/new',
    path: '/notas-debito/new',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdNotasDebitoNoteIdRoute =
  CompaniesCompanyIdNotasDebitoNoteIdRouteImport.update({
    id: '/notas-debito/$noteId',
    path: '/notas-debito/$noteId',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdNotasCreditoNewRoute =
  CompaniesCompanyIdNotasCreditoNewRouteImport.update({
    id: '/notas-credito/new',
    path: '/notas-credito/new',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdInventarioReportesRoute =
  CompaniesCompanyIdInventarioReportesRouteImport.update({
    id: '/inventario/reportes',
    path: '/inventario/reportes',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdInventarioBodegasRoute =
  CompaniesCompanyIdInventarioBodegasRouteImport.update({
    id: '/inventario/bodegas',
    path: '/inventario/bodegas',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdImpuestosConfiguracionRoute =
  CompaniesCompanyIdImpuestosConfiguracionRouteImport.update({
    id: '/impuestos/configuracion',
    path: '/impuestos/configuracion',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdImpuestosEventIdRoute =
  CompaniesCompanyIdImpuestosEventIdRouteImport.update({
    id: '/impuestos/$eventId',
    path: '/impuestos/$eventId',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdFacturasNewRoute =
  CompaniesCompanyIdFacturasNewRouteImport.update({
    id: '/facturas/new',
    path: '/facturas/new',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdEgresosNewRoute =
  CompaniesCompanyIdEgresosNewRouteImport.update({
    id: '/egresos/new',
    path: '/egresos/new',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdEgresosVoucherIdRoute =
  CompaniesCompanyIdEgresosVoucherIdRouteImport.update({
    id: '/egresos/$voucherId',
    path: '/egresos/$voucherId',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdDocumentosSoporteNewRoute =
  CompaniesCompanyIdDocumentosSoporteNewRouteImport.update({
    id: '/documentos-soporte/new',
    path: '/documentos-soporte/new',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdDocumentosSoporteDocumentIdRoute =
  CompaniesCompanyIdDocumentosSoporteDocumentIdRouteImport.update({
    id: '/documentos-soporte/$documentId',
    path: '/documentos-soporte/$documentId',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdContabilidadSaldosInicialesRoute =
  CompaniesCompanyIdContabilidadSaldosInicialesRouteImport.update({
    id: '/contabilidad/saldos-iniciales',
    path: '/contabilidad/saldos-iniciales',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdContabilidadCuentasRoute =
  CompaniesCompanyIdContabilidadCuentasRouteImport.update({
    id: '/contabilidad/cuentas',
    path: '/contabilidad/cuentas',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdComprasNewRoute =
  CompaniesCompanyIdComprasNewRouteImport.update({
    id: '/compras/new',
    path: '/compras/new',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdComprasInvoiceIdRoute =
  CompaniesCompanyIdComprasInvoiceIdRouteImport.update({
    id: '/compras/$invoiceId',
    path: '/compras/$invoiceId',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdCarteraTerceroIdRoute =
  CompaniesCompanyIdCarteraTerceroIdRouteImport.update({
    id: '/cartera/$terceroId',
    path: '/cartera/$terceroId',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdPosAjustesIndexRoute =
  CompaniesCompanyIdPosAjustesIndexRouteImport.update({
    id: '/pos/ajustes/',
    path: '/pos/ajustes/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdNotasCreditoNoteIdIndexRoute =
  CompaniesCompanyIdNotasCreditoNoteIdIndexRouteImport.update({
    id: '/notas-credito/$noteId/',
    path: '/notas-credito/$noteId/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdNominaPayslipsIndexRoute =
  CompaniesCompanyIdNominaPayslipsIndexRouteImport.update({
    id: '/nomina/payslips/',
    path: '/nomina/payslips/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdNominaLiquidacionesIndexRoute =
  CompaniesCompanyIdNominaLiquidacionesIndexRouteImport.update({
    id: '/nomina/liquidaciones/',
    path: '/nomina/liquidaciones/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdNominaEmpleadosIndexRoute =
  CompaniesCompanyIdNominaEmpleadosIndexRouteImport.update({
    id: '/nomina/empleados/',
    path: '/nomina/empleados/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdNominaDefinitivasIndexRoute =
  CompaniesCompanyIdNominaDefinitivasIndexRouteImport.update({
    id: '/nomina/definitivas/',
    path: '/nomina/definitivas/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdNominaAjustesIndexRoute =
  CompaniesCompanyIdNominaAjustesIndexRouteImport.update({
    id: '/nomina/ajustes/',
    path: '/nomina/ajustes/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdInventarioMovimientosIndexRoute =
  CompaniesCompanyIdInventarioMovimientosIndexRouteImport.update({
    id: '/inventario/movimientos/',
    path: '/inventario/movimientos/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdInventarioConteosIndexRoute =
  CompaniesCompanyIdInventarioConteosIndexRouteImport.update({
    id: '/inventario/conteos/',
    path: '/inventario/conteos/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdFacturasInvoiceIdIndexRoute =
  CompaniesCompanyIdFacturasInvoiceIdIndexRouteImport.update({
    id: '/facturas/$invoiceId/',
    path: '/facturas/$invoiceId/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdContabilidadMayorIndexRoute =
  CompaniesCompanyIdContabilidadMayorIndexRouteImport.update({
    id: '/contabilidad/mayor/',
    path: '/contabilidad/mayor/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdContabilidadDiarioIndexRoute =
  CompaniesCompanyIdContabilidadDiarioIndexRouteImport.update({
    id: '/contabilidad/diario/',
    path: '/contabilidad/diario/',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdPosAjustesNewRoute =
  CompaniesCompanyIdPosAjustesNewRouteImport.update({
    id: '/pos/ajustes/new',
    path: '/pos/ajustes/new',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdPosAjustesAdjustmentIdRoute =
  CompaniesCompanyIdPosAjustesAdjustmentIdRouteImport.update({
    id: '/pos/ajustes/$adjustmentId',
    path: '/pos/ajustes/$adjustmentId',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdNotasCreditoNoteIdPreviewRoute =
  CompaniesCompanyIdNotasCreditoNoteIdPreviewRouteImport.update({
    id: '/notas-credito/$noteId/preview',
    path: '/notas-credito/$noteId/preview',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdNominaPayslipsNewRoute =
  CompaniesCompanyIdNominaPayslipsNewRouteImport.update({
    id: '/nomina/payslips/new',
    path: '/nomina/payslips/new',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdNominaPayslipsPayslipIdRoute =
  CompaniesCompanyIdNominaPayslipsPayslipIdRouteImport.update({
    id: '/nomina/payslips/$payslipId',
    path: '/nomina/payslips/$payslipId',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdNominaLiquidacionesNewRoute =
  CompaniesCompanyIdNominaLiquidacionesNewRouteImport.update({
    id: '/nomina/liquidaciones/new',
    path: '/nomina/liquidaciones/new',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdNominaLiquidacionesLiquidationIdRoute =
  CompaniesCompanyIdNominaLiquidacionesLiquidationIdRouteImport.update({
    id: '/nomina/liquidaciones/$liquidationId',
    path: '/nomina/liquidaciones/$liquidationId',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdNominaEmpleadosNewRoute =
  CompaniesCompanyIdNominaEmpleadosNewRouteImport.update({
    id: '/nomina/empleados/new',
    path: '/nomina/empleados/new',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdNominaEmpleadosEmployeeIdRoute =
  CompaniesCompanyIdNominaEmpleadosEmployeeIdRouteImport.update({
    id: '/nomina/empleados/$employeeId',
    path: '/nomina/empleados/$employeeId',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdNominaDefinitivasNewRoute =
  CompaniesCompanyIdNominaDefinitivasNewRouteImport.update({
    id: '/nomina/definitivas/new',
    path: '/nomina/definitivas/new',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdNominaDefinitivasSettlementIdRoute =
  CompaniesCompanyIdNominaDefinitivasSettlementIdRouteImport.update({
    id: '/nomina/definitivas/$settlementId',
    path: '/nomina/definitivas/$settlementId',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdNominaAjustesNewRoute =
  CompaniesCompanyIdNominaAjustesNewRouteImport.update({
    id: '/nomina/ajustes/new',
    path: '/nomina/ajustes/new',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdNominaAjustesAdjustmentIdRoute =
  CompaniesCompanyIdNominaAjustesAdjustmentIdRouteImport.update({
    id: '/nomina/ajustes/$adjustmentId',
    path: '/nomina/ajustes/$adjustmentId',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdInventarioTrasladosNewRoute =
  CompaniesCompanyIdInventarioTrasladosNewRouteImport.update({
    id: '/inventario/traslados/new',
    path: '/inventario/traslados/new',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdInventarioMovimientosNewRoute =
  CompaniesCompanyIdInventarioMovimientosNewRouteImport.update({
    id: '/inventario/movimientos/new',
    path: '/inventario/movimientos/new',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdInventarioConteosCountIdRoute =
  CompaniesCompanyIdInventarioConteosCountIdRouteImport.update({
    id: '/inventario/conteos/$countId',
    path: '/inventario/conteos/$countId',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdFacturasInvoiceIdPreviewRoute =
  CompaniesCompanyIdFacturasInvoiceIdPreviewRouteImport.update({
    id: '/facturas/$invoiceId/preview',
    path: '/facturas/$invoiceId/preview',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdContabilidadMayorAccountCodeRoute =
  CompaniesCompanyIdContabilidadMayorAccountCodeRouteImport.update({
    id: '/contabilidad/mayor/$accountCode',
    path: '/contabilidad/mayor/$accountCode',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdContabilidadDiarioNuevoRoute =
  CompaniesCompanyIdContabilidadDiarioNuevoRouteImport.update({
    id: '/contabilidad/diario/nuevo',
    path: '/contabilidad/diario/nuevo',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)
const CompaniesCompanyIdContabilidadDiarioEntryIdRoute =
  CompaniesCompanyIdContabilidadDiarioEntryIdRouteImport.update({
    id: '/contabilidad/diario/$entryId',
    path: '/contabilidad/diario/$entryId',
    getParentRoute: () => CompaniesCompanyIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/profile': typeof ProfileRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/companies/$companyId': typeof CompaniesCompanyIdRouteWithChildren
  '/companies/new': typeof CompaniesNewRoute
  '/settings/tokens': typeof SettingsTokensRoute
  '/teams/$teamId': typeof TeamsTeamIdRoute
  '/teams/accept': typeof TeamsAcceptRoute
  '/companies/': typeof CompaniesIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/subscription/': typeof SubscriptionIndexRoute
  '/teams/': typeof TeamsIndexRoute
  '/companies/$companyId/bancos': typeof CompaniesCompanyIdBancosRoute
  '/companies/$companyId/edit': typeof CompaniesCompanyIdEditRoute
  '/invite/accept/$token': typeof InviteAcceptTokenRoute
  '/invite/decline/$token': typeof InviteDeclineTokenRoute
  '/companies/$companyId/': typeof CompaniesCompanyIdIndexRoute
  '/companies/$companyId/cartera/$terceroId': typeof CompaniesCompanyIdCarteraTerceroIdRoute
  '/companies/$companyId/compras/$invoiceId': typeof CompaniesCompanyIdComprasInvoiceIdRoute
  '/companies/$companyId/compras/new': typeof CompaniesCompanyIdComprasNewRoute
  '/companies/$companyId/contabilidad/cuentas': typeof CompaniesCompanyIdContabilidadCuentasRoute
  '/companies/$companyId/contabilidad/saldos-iniciales': typeof CompaniesCompanyIdContabilidadSaldosInicialesRoute
  '/companies/$companyId/documentos-soporte/$documentId': typeof CompaniesCompanyIdDocumentosSoporteDocumentIdRoute
  '/companies/$companyId/documentos-soporte/new': typeof CompaniesCompanyIdDocumentosSoporteNewRoute
  '/companies/$companyId/egresos/$voucherId': typeof CompaniesCompanyIdEgresosVoucherIdRoute
  '/companies/$companyId/egresos/new': typeof CompaniesCompanyIdEgresosNewRoute
  '/companies/$companyId/facturas/new': typeof CompaniesCompanyIdFacturasNewRoute
  '/companies/$companyId/impuestos/$eventId': typeof CompaniesCompanyIdImpuestosEventIdRoute
  '/companies/$companyId/impuestos/configuracion': typeof CompaniesCompanyIdImpuestosConfiguracionRoute
  '/companies/$companyId/inventario/bodegas': typeof CompaniesCompanyIdInventarioBodegasRoute
  '/companies/$companyId/inventario/reportes': typeof CompaniesCompanyIdInventarioReportesRoute
  '/companies/$companyId/notas-credito/new': typeof CompaniesCompanyIdNotasCreditoNewRoute
  '/companies/$companyId/notas-debito/$noteId': typeof CompaniesCompanyIdNotasDebitoNoteIdRoute
  '/companies/$companyId/notas-debito/new': typeof CompaniesCompanyIdNotasDebitoNewRoute
  '/companies/$companyId/pos/$documentId': typeof CompaniesCompanyIdPosDocumentIdRoute
  '/companies/$companyId/pos/new': typeof CompaniesCompanyIdPosNewRoute
  '/companies/$companyId/productos/$productId': typeof CompaniesCompanyIdProductosProductIdRoute
  '/companies/$companyId/productos/new': typeof CompaniesCompanyIdProductosNewRoute
  '/companies/$companyId/recibidas/$receivedId': typeof CompaniesCompanyIdRecibidasReceivedIdRoute
  '/companies/$companyId/recibidas/buzon': typeof CompaniesCompanyIdRecibidasBuzonRoute
  '/companies/$companyId/recibos/$receiptId': typeof CompaniesCompanyIdRecibosReceiptIdRoute
  '/companies/$companyId/recibos/new': typeof CompaniesCompanyIdRecibosNewRoute
  '/companies/$companyId/reportes/balance-general': typeof CompaniesCompanyIdReportesBalanceGeneralRoute
  '/companies/$companyId/reportes/estado-resultados': typeof CompaniesCompanyIdReportesEstadoResultadosRoute
  '/companies/$companyId/reportes/iva': typeof CompaniesCompanyIdReportesIvaRoute
  '/companies/$companyId/reportes/retenciones': typeof CompaniesCompanyIdReportesRetencionesRoute
  '/companies/$companyId/terceros/$terceroId': typeof CompaniesCompanyIdTercerosTerceroIdRoute
  '/companies/$companyId/terceros/new': typeof CompaniesCompanyIdTercerosNewRoute
  '/companies/$companyId/archivos/': typeof CompaniesCompanyIdArchivosIndexRoute
  '/companies/$companyId/cartera/': typeof CompaniesCompanyIdCarteraIndexRoute
  '/companies/$companyId/compras/': typeof CompaniesCompanyIdComprasIndexRoute
  '/companies/$companyId/contabilidad/': typeof CompaniesCompanyIdContabilidadIndexRoute
  '/companies/$companyId/documentos-soporte/': typeof CompaniesCompanyIdDocumentosSoporteIndexRoute
  '/companies/$companyId/egresos/': typeof CompaniesCompanyIdEgresosIndexRoute
  '/companies/$companyId/facturas/': typeof CompaniesCompanyIdFacturasIndexRoute
  '/companies/$companyId/importaciones/': typeof CompaniesCompanyIdImportacionesIndexRoute
  '/companies/$companyId/impuestos/': typeof CompaniesCompanyIdImpuestosIndexRoute
  '/companies/$companyId/inventario/': typeof CompaniesCompanyIdInventarioIndexRoute
  '/companies/$companyId/nomina/': typeof CompaniesCompanyIdNominaIndexRoute
  '/companies/$companyId/notas-credito/': typeof CompaniesCompanyIdNotasCreditoIndexRoute
  '/companies/$companyId/notas-debito/': typeof CompaniesCompanyIdNotasDebitoIndexRoute
  '/companies/$companyId/pos/': typeof CompaniesCompanyIdPosIndexRoute
  '/companies/$companyId/productos/': typeof CompaniesCompanyIdProductosIndexRoute
  '/companies/$companyId/puc/': typeof CompaniesCompanyIdPucIndexRoute
  '/companies/$companyId/recibidas/': typeof CompaniesCompanyIdRecibidasIndexRoute
  '/companies/$companyId/recibos/': typeof CompaniesCompanyIdRecibosIndexRoute
  '/companies/$companyId/reportes/': typeof CompaniesCompanyIdReportesIndexRoute
  '/companies/$companyId/resoluciones/': typeof CompaniesCompanyIdResolucionesIndexRoute
  '/companies/$companyId/terceros/': typeof CompaniesCompanyIdTercerosIndexRoute
  '/companies/$companyId/contabilidad/diario/$entryId': typeof CompaniesCompanyIdContabilidadDiarioEntryIdRoute
  '/companies/$companyId/contabilidad/diario/nuevo': typeof CompaniesCompanyIdContabilidadDiarioNuevoRoute
  '/companies/$companyId/contabilidad/mayor/$accountCode': typeof CompaniesCompanyIdContabilidadMayorAccountCodeRoute
  '/companies/$companyId/facturas/$invoiceId/preview': typeof CompaniesCompanyIdFacturasInvoiceIdPreviewRoute
  '/companies/$companyId/inventario/conteos/$countId': typeof CompaniesCompanyIdInventarioConteosCountIdRoute
  '/companies/$companyId/inventario/movimientos/new': typeof CompaniesCompanyIdInventarioMovimientosNewRoute
  '/companies/$companyId/inventario/traslados/new': typeof CompaniesCompanyIdInventarioTrasladosNewRoute
  '/companies/$companyId/nomina/ajustes/$adjustmentId': typeof CompaniesCompanyIdNominaAjustesAdjustmentIdRoute
  '/companies/$companyId/nomina/ajustes/new': typeof CompaniesCompanyIdNominaAjustesNewRoute
  '/companies/$companyId/nomina/definitivas/$settlementId': typeof CompaniesCompanyIdNominaDefinitivasSettlementIdRoute
  '/companies/$companyId/nomina/definitivas/new': typeof CompaniesCompanyIdNominaDefinitivasNewRoute
  '/companies/$companyId/nomina/empleados/$employeeId': typeof CompaniesCompanyIdNominaEmpleadosEmployeeIdRoute
  '/companies/$companyId/nomina/empleados/new': typeof CompaniesCompanyIdNominaEmpleadosNewRoute
  '/companies/$companyId/nomina/liquidaciones/$liquidationId': typeof CompaniesCompanyIdNominaLiquidacionesLiquidationIdRoute
  '/companies/$companyId/nomina/liquidaciones/new': typeof CompaniesCompanyIdNominaLiquidacionesNewRoute
  '/companies/$companyId/nomina/payslips/$payslipId': typeof CompaniesCompanyIdNominaPayslipsPayslipIdRoute
  '/companies/$companyId/nomina/payslips/new': typeof CompaniesCompanyIdNominaPayslipsNewRoute
  '/companies/$companyId/notas-credito/$noteId/preview': typeof CompaniesCompanyIdNotasCreditoNoteIdPreviewRoute
  '/companies/$companyId/pos/ajustes/$adjustmentId': typeof CompaniesCompanyIdPosAjustesAdjustmentIdRoute
  '/companies/$companyId/pos/ajustes/new': typeof CompaniesCompanyIdPosAjustesNewRoute
  '/companies/$companyId/contabilidad/diario/': typeof CompaniesCompanyIdContabilidadDiarioIndexRoute
  '/companies/$companyId/contabilidad/mayor/': typeof CompaniesCompanyIdContabilidadMayorIndexRoute
  '/companies/$companyId/facturas/$invoiceId/': typeof CompaniesCompanyIdFacturasInvoiceIdIndexRoute
  '/companies/$companyId/inventario/conteos/': typeof CompaniesCompanyIdInventarioConteosIndexRoute
  '/companies/$companyId/inventario/movimientos/': typeof CompaniesCompanyIdInventarioMovimientosIndexRoute
  '/companies/$companyId/nomina/ajustes/': typeof CompaniesCompanyIdNominaAjustesIndexRoute
  '/companies/$companyId/nomina/definitivas/': typeof CompaniesCompanyIdNominaDefinitivasIndexRoute
  '/companies/$companyId/nomina/empleados/': typeof CompaniesCompanyIdNominaEmpleadosIndexRoute
  '/companies/$companyId/nomina/liquidaciones/': typeof CompaniesCompanyIdNominaLiquidacionesIndexRoute
  '/companies/$companyId/nomina/payslips/': typeof CompaniesCompanyIdNominaPayslipsIndexRoute
  '/companies/$companyId/notas-credito/$noteId/': typeof CompaniesCompanyIdNotasCreditoNoteIdIndexRoute
  '/companies/$companyId/pos/ajustes/': typeof CompaniesCompanyIdPosAjustesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/profile': typeof ProfileRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/companies/new': typeof CompaniesNewRoute
  '/settings/tokens': typeof SettingsTokensRoute
  '/teams/$teamId': typeof TeamsTeamIdRoute
  '/teams/accept': typeof TeamsAcceptRoute
  '/companies': typeof CompaniesIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/subscription': typeof SubscriptionIndexRoute
  '/teams': typeof TeamsIndexRoute
  '/companies/$companyId/bancos': typeof CompaniesCompanyIdBancosRoute
  '/companies/$companyId/edit': typeof CompaniesCompanyIdEditRoute
  '/invite/accept/$token': typeof InviteAcceptTokenRoute
  '/invite/decline/$token': typeof InviteDeclineTokenRoute
  '/companies/$companyId': typeof CompaniesCompanyIdIndexRoute
  '/companies/$companyId/cartera/$terceroId': typeof CompaniesCompanyIdCarteraTerceroIdRoute
  '/companies/$companyId/compras/$invoiceId': typeof CompaniesCompanyIdComprasInvoiceIdRoute
  '/companies/$companyId/compras/new': typeof CompaniesCompanyIdComprasNewRoute
  '/companies/$companyId/contabilidad/cuentas': typeof CompaniesCompanyIdContabilidadCuentasRoute
  '/companies/$companyId/contabilidad/saldos-iniciales': typeof CompaniesCompanyIdContabilidadSaldosInicialesRoute
  '/companies/$companyId/documentos-soporte/$documentId': typeof CompaniesCompanyIdDocumentosSoporteDocumentIdRoute
  '/companies/$companyId/documentos-soporte/new': typeof CompaniesCompanyIdDocumentosSoporteNewRoute
  '/companies/$companyId/egresos/$voucherId': typeof CompaniesCompanyIdEgresosVoucherIdRoute
  '/companies/$companyId/egresos/new': typeof CompaniesCompanyIdEgresosNewRoute
  '/companies/$companyId/facturas/new': typeof CompaniesCompanyIdFacturasNewRoute
  '/companies/$companyId/impuestos/$eventId': typeof CompaniesCompanyIdImpuestosEventIdRoute
  '/companies/$companyId/impuestos/configuracion': typeof CompaniesCompanyIdImpuestosConfiguracionRoute
  '/companies/$companyId/inventario/bodegas': typeof CompaniesCompanyIdInventarioBodegasRoute
  '/companies/$companyId/inventario/reportes': typeof CompaniesCompanyIdInventarioReportesRoute
  '/companies/$companyId/notas-credito/new': typeof CompaniesCompanyIdNotasCreditoNewRoute
  '/companies/$companyId/notas-debito/$noteId': typeof CompaniesCompanyIdNotasDebitoNoteIdRoute
  '/companies/$companyId/notas-debito/new': typeof CompaniesCompanyIdNotasDebitoNewRoute
  '/companies/$companyId/pos/$documentId': typeof CompaniesCompanyIdPosDocumentIdRoute
  '/companies/$companyId/pos/new': typeof CompaniesCompanyIdPosNewRoute
  '/companies/$companyId/productos/$productId': typeof CompaniesCompanyIdProductosProductIdRoute
  '/companies/$companyId/productos/new': typeof CompaniesCompanyIdProductosNewRoute
  '/companies/$companyId/recibidas/$receivedId': typeof CompaniesCompanyIdRecibidasReceivedIdRoute
  '/companies/$companyId/recibidas/buzon': typeof CompaniesCompanyIdRecibidasBuzonRoute
  '/companies/$companyId/recibos/$receiptId': typeof CompaniesCompanyIdRecibosReceiptIdRoute
  '/companies/$companyId/recibos/new': typeof CompaniesCompanyIdRecibosNewRoute
  '/companies/$companyId/reportes/balance-general': typeof CompaniesCompanyIdReportesBalanceGeneralRoute
  '/companies/$companyId/reportes/estado-resultados': typeof CompaniesCompanyIdReportesEstadoResultadosRoute
  '/companies/$companyId/reportes/iva': typeof CompaniesCompanyIdReportesIvaRoute
  '/companies/$companyId/reportes/retenciones': typeof CompaniesCompanyIdReportesRetencionesRoute
  '/companies/$companyId/terceros/$terceroId': typeof CompaniesCompanyIdTercerosTerceroIdRoute
  '/companies/$companyId/terceros/new': typeof CompaniesCompanyIdTercerosNewRoute
  '/companies/$companyId/archivos': typeof CompaniesCompanyIdArchivosIndexRoute
  '/companies/$companyId/cartera': typeof CompaniesCompanyIdCarteraIndexRoute
  '/companies/$companyId/compras': typeof CompaniesCompanyIdComprasIndexRoute
  '/companies/$companyId/contabilidad': typeof CompaniesCompanyIdContabilidadIndexRoute
  '/companies/$companyId/documentos-soporte': typeof CompaniesCompanyIdDocumentosSoporteIndexRoute
  '/companies/$companyId/egresos': typeof CompaniesCompanyIdEgresosIndexRoute
  '/companies/$companyId/facturas': typeof CompaniesCompanyIdFacturasIndexRoute
  '/companies/$companyId/importaciones': typeof CompaniesCompanyIdImportacionesIndexRoute
  '/companies/$companyId/impuestos': typeof CompaniesCompanyIdImpuestosIndexRoute
  '/companies/$companyId/inventario': typeof CompaniesCompanyIdInventarioIndexRoute
  '/companies/$companyId/nomina': typeof CompaniesCompanyIdNominaIndexRoute
  '/companies/$companyId/notas-credito': typeof CompaniesCompanyIdNotasCreditoIndexRoute
  '/companies/$companyId/notas-debito': typeof CompaniesCompanyIdNotasDebitoIndexRoute
  '/companies/$companyId/pos': typeof CompaniesCompanyIdPosIndexRoute
  '/companies/$companyId/productos': typeof CompaniesCompanyIdProductosIndexRoute
  '/companies/$companyId/puc': typeof CompaniesCompanyIdPucIndexRoute
  '/companies/$companyId/recibidas': typeof CompaniesCompanyIdRecibidasIndexRoute
  '/companies/$companyId/recibos': typeof CompaniesCompanyIdRecibosIndexRoute
  '/companies/$companyId/reportes': typeof CompaniesCompanyIdReportesIndexRoute
  '/companies/$companyId/resoluciones': typeof CompaniesCompanyIdResolucionesIndexRoute
  '/companies/$companyId/terceros': typeof CompaniesCompanyIdTercerosIndexRoute
  '/companies/$companyId/contabilidad/diario/$entryId': typeof CompaniesCompanyIdContabilidadDiarioEntryIdRoute
  '/companies/$companyId/contabilidad/diario/nuevo': typeof CompaniesCompanyIdContabilidadDiarioNuevoRoute
  '/companies/$companyId/contabilidad/mayor/$accountCode': typeof CompaniesCompanyIdContabilidadMayorAccountCodeRoute
  '/companies/$companyId/facturas/$invoiceId/preview': typeof CompaniesCompanyIdFacturasInvoiceIdPreviewRoute
  '/companies/$companyId/inventario/conteos/$countId': typeof CompaniesCompanyIdInventarioConteosCountIdRoute
  '/companies/$companyId/inventario/movimientos/new': typeof CompaniesCompanyIdInventarioMovimientosNewRoute
  '/companies/$companyId/inventario/traslados/new': typeof CompaniesCompanyIdInventarioTrasladosNewRoute
  '/companies/$companyId/nomina/ajustes/$adjustmentId': typeof CompaniesCompanyIdNominaAjustesAdjustmentIdRoute
  '/companies/$companyId/nomina/ajustes/new': typeof CompaniesCompanyIdNominaAjustesNewRoute
  '/companies/$companyId/nomina/definitivas/$settlementId': typeof CompaniesCompanyIdNominaDefinitivasSettlementIdRoute
  '/companies/$companyId/nomina/definitivas/new': typeof CompaniesCompanyIdNominaDefinitivasNewRoute
  '/companies/$companyId/nomina/empleados/$employeeId': typeof CompaniesCompanyIdNominaEmpleadosEmployeeIdRoute
  '/companies/$companyId/nomina/empleados/new': typeof CompaniesCompanyIdNominaEmpleadosNewRoute
  '/companies/$companyId/nomina/liquidaciones/$liquidationId': typeof CompaniesCompanyIdNominaLiquidacionesLiquidationIdRoute
  '/companies/$companyId/nomina/liquidaciones/new': typeof CompaniesCompanyIdNominaLiquidacionesNewRoute
  '/companies/$companyId/nomina/payslips/$payslipId': typeof CompaniesCompanyIdNominaPayslipsPayslipIdRoute
  '/companies/$companyId/nomina/payslips/new': typeof CompaniesCompanyIdNominaPayslipsNewRoute
  '/companies/$companyId/notas-credito/$noteId/preview': typeof CompaniesCompanyIdNotasCreditoNoteIdPreviewRoute
  '/companies/$companyId/pos/ajustes/$adjustmentId': typeof CompaniesCompanyIdPosAjustesAdjustmentIdRoute
  '/companies/$companyId/pos/ajustes/new': typeof CompaniesCompanyIdPosAjustesNewRoute
  '/companies/$companyId/contabilidad/diario': typeof CompaniesCompanyIdContabilidadDiarioIndexRoute
  '/companies/$companyId/contabilidad/mayor': typeof CompaniesCompanyIdContabilidadMayorIndexRoute
  '/companies/$companyId/facturas/$invoiceId': typeof CompaniesCompanyIdFacturasInvoiceIdIndexRoute
  '/companies/$companyId/inventario/conteos': typeof CompaniesCompanyIdInventarioConteosIndexRoute
  '/companies/$companyId/inventario/movimientos': typeof CompaniesCompanyIdInventarioMovimientosIndexRoute
  '/companies/$companyId/nomina/ajustes': typeof CompaniesCompanyIdNominaAjustesIndexRoute
  '/companies/$companyId/nomina/definitivas': typeof CompaniesCompanyIdNominaDefinitivasIndexRoute
  '/companies/$companyId/nomina/empleados': typeof CompaniesCompanyIdNominaEmpleadosIndexRoute
  '/companies/$companyId/nomina/liquidaciones': typeof CompaniesCompanyIdNominaLiquidacionesIndexRoute
  '/companies/$companyId/nomina/payslips': typeof CompaniesCompanyIdNominaPayslipsIndexRoute
  '/companies/$companyId/notas-credito/$noteId': typeof CompaniesCompanyIdNotasCreditoNoteIdIndexRoute
  '/companies/$companyId/pos/ajustes': typeof CompaniesCompanyIdPosAjustesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/profile': typeof ProfileRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/companies/$companyId': typeof CompaniesCompanyIdRouteWithChildren
  '/companies/new': typeof CompaniesNewRoute
  '/settings/tokens': typeof SettingsTokensRoute
  '/teams/$teamId': typeof TeamsTeamIdRoute
  '/teams/accept': typeof TeamsAcceptRoute
  '/companies/': typeof CompaniesIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/subscription/': typeof SubscriptionIndexRoute
  '/teams/': typeof TeamsIndexRoute
  '/companies/$companyId/bancos': typeof CompaniesCompanyIdBancosRoute
  '/companies/$companyId/edit': typeof CompaniesCompanyIdEditRoute
  '/invite/accept/$token': typeof InviteAcceptTokenRoute
  '/invite/decline/$token': typeof InviteDeclineTokenRoute
  '/companies/$companyId/': typeof CompaniesCompanyIdIndexRoute
  '/companies/$companyId/cartera/$terceroId': typeof CompaniesCompanyIdCarteraTerceroIdRoute
  '/companies/$companyId/compras/$invoiceId': typeof CompaniesCompanyIdComprasInvoiceIdRoute
  '/companies/$companyId/compras/new': typeof CompaniesCompanyIdComprasNewRoute
  '/companies/$companyId/contabilidad/cuentas': typeof CompaniesCompanyIdContabilidadCuentasRoute
  '/companies/$companyId/contabilidad/saldos-iniciales': typeof CompaniesCompanyIdContabilidadSaldosInicialesRoute
  '/companies/$companyId/documentos-soporte/$documentId': typeof CompaniesCompanyIdDocumentosSoporteDocumentIdRoute
  '/companies/$companyId/documentos-soporte/new': typeof CompaniesCompanyIdDocumentosSoporteNewRoute
  '/companies/$companyId/egresos/$voucherId': typeof CompaniesCompanyIdEgresosVoucherIdRoute
  '/companies/$companyId/egresos/new': typeof CompaniesCompanyIdEgresosNewRoute
  '/companies/$companyId/facturas/new': typeof CompaniesCompanyIdFacturasNewRoute
  '/companies/$companyId/impuestos/$eventId': typeof CompaniesCompanyIdImpuestosEventIdRoute
  '/companies/$companyId/impuestos/configuracion': typeof CompaniesCompanyIdImpuestosConfiguracionRoute
  '/companies/$companyId/inventario/bodegas': typeof CompaniesCompanyIdInventarioBodegasRoute
  '/companies/$companyId/inventario/reportes': typeof CompaniesCompanyIdInventarioReportesRoute
  '/companies/$companyId/notas-credito/new': typeof CompaniesCompanyIdNotasCreditoNewRoute
  '/companies/$companyId/notas-debito/$noteId': typeof CompaniesCompanyIdNotasDebitoNoteIdRoute
  '/companies/$companyId/notas-debito/new': typeof CompaniesCompanyIdNotasDebitoNewRoute
  '/companies/$companyId/pos/$documentId': typeof CompaniesCompanyIdPosDocumentIdRoute
  '/companies/$companyId/pos/new': typeof CompaniesCompanyIdPosNewRoute
  '/companies/$companyId/productos/$productId': typeof CompaniesCompanyIdProductosProductIdRoute
  '/companies/$companyId/productos/new': typeof CompaniesCompanyIdProductosNewRoute
  '/companies/$companyId/recibidas/$receivedId': typeof CompaniesCompanyIdRecibidasReceivedIdRoute
  '/companies/$companyId/recibidas/buzon': typeof CompaniesCompanyIdRecibidasBuzonRoute
  '/companies/$companyId/recibos/$receiptId': typeof CompaniesCompanyIdRecibosReceiptIdRoute
  '/companies/$companyId/recibos/new': typeof CompaniesCompanyIdRecibosNewRoute
  '/companies/$companyId/reportes/balance-general': typeof CompaniesCompanyIdReportesBalanceGeneralRoute
  '/companies/$companyId/reportes/estado-resultados': typeof CompaniesCompanyIdReportesEstadoResultadosRoute
  '/companies/$companyId/reportes/iva': typeof CompaniesCompanyIdReportesIvaRoute
  '/companies/$companyId/reportes/retenciones': typeof CompaniesCompanyIdReportesRetencionesRoute
  '/companies/$companyId/terceros/$terceroId': typeof CompaniesCompanyIdTercerosTerceroIdRoute
  '/companies/$companyId/terceros/new': typeof CompaniesCompanyIdTercerosNewRoute
  '/companies/$companyId/archivos/': typeof CompaniesCompanyIdArchivosIndexRoute
  '/companies/$companyId/cartera/': typeof CompaniesCompanyIdCarteraIndexRoute
  '/companies/$companyId/compras/': typeof CompaniesCompanyIdComprasIndexRoute
  '/companies/$companyId/contabilidad/': typeof CompaniesCompanyIdContabilidadIndexRoute
  '/companies/$companyId/documentos-soporte/': typeof CompaniesCompanyIdDocumentosSoporteIndexRoute
  '/companies/$companyId/egresos/': typeof CompaniesCompanyIdEgresosIndexRoute
  '/companies/$companyId/facturas/': typeof CompaniesCompanyIdFacturasIndexRoute
  '/companies/$companyId/importaciones/': typeof CompaniesCompanyIdImportacionesIndexRoute
  '/companies/$companyId/impuestos/': typeof CompaniesCompanyIdImpuestosIndexRoute
  '/companies/$companyId/inventario/': typeof CompaniesCompanyIdInventarioIndexRoute
  '/companies/$companyId/nomina/': typeof CompaniesCompanyIdNominaIndexRoute
  '/companies/$companyId/notas-credito/': typeof CompaniesCompanyIdNotasCreditoIndexRoute
  '/companies/$companyId/notas-debito/': typeof CompaniesCompanyIdNotasDebitoIndexRoute
  '/companies/$companyId/pos/': typeof CompaniesCompanyIdPosIndexRoute
  '/companies/$companyId/productos/': typeof CompaniesCompanyIdProductosIndexRoute
  '/companies/$companyId/puc/': typeof CompaniesCompanyIdPucIndexRoute
  '/companies/$companyId/recibidas/': typeof CompaniesCompanyIdRecibidasIndexRoute
  '/companies/$companyId/recibos/': typeof CompaniesCompanyIdRecibosIndexRoute
  '/companies/$companyId/reportes/': typeof CompaniesCompanyIdReportesIndexRoute
  '/companies/$companyId/resoluciones/': typeof CompaniesCompanyIdResolucionesIndexRoute
  '/companies/$companyId/terceros/': typeof CompaniesCompanyIdTercerosIndexRoute
  '/companies/$companyId/contabilidad/diario/$entryId': typeof CompaniesCompanyIdContabilidadDiarioEntryIdRoute
  '/companies/$companyId/contabilidad/diario/nuevo': typeof CompaniesCompanyIdContabilidadDiarioNuevoRoute
  '/companies/$companyId/contabilidad/mayor/$accountCode': typeof CompaniesCompanyIdContabilidadMayorAccountCodeRoute
  '/companies/$companyId/facturas/$invoiceId/preview': typeof CompaniesCompanyIdFacturasInvoiceIdPreviewRoute
  '/companies/$companyId/inventario/conteos/$countId': typeof CompaniesCompanyIdInventarioConteosCountIdRoute
  '/companies/$companyId/inventario/movimientos/new': typeof CompaniesCompanyIdInventarioMovimientosNewRoute
  '/companies/$companyId/inventario/traslados/new': typeof CompaniesCompanyIdInventarioTrasladosNewRoute
  '/companies/$companyId/nomina/ajustes/$adjustmentId': typeof CompaniesCompanyIdNominaAjustesAdjustmentIdRoute
  '/companies/$companyId/nomina/ajustes/new': typeof CompaniesCompanyIdNominaAjustesNewRoute
  '/companies/$companyId/nomina/definitivas/$settlementId': typeof CompaniesCompanyIdNominaDefinitivasSettlementIdRoute
  '/companies/$companyId/nomina/definitivas/new': typeof CompaniesCompanyIdNominaDefinitivasNewRoute
  '/companies/$companyId/nomina/empleados/$employeeId': typeof CompaniesCompanyIdNominaEmpleadosEmployeeIdRoute
  '/companies/$companyId/nomina/empleados/new': typeof CompaniesCompanyIdNominaEmpleadosNewRoute
  '/companies/$companyId/nomina/liquidaciones/$liquidationId': typeof CompaniesCompanyIdNominaLiquidacionesLiquidationIdRoute
  '/companies/$companyId/nomina/liquidaciones/new': typeof CompaniesCompanyIdNominaLiquidacionesNewRoute
  '/companies/$companyId/nomina/payslips/$payslipId': typeof CompaniesCompanyIdNominaPayslipsPayslipIdRoute
  '/companies/$companyId/nomina/payslips/new': typeof CompaniesCompanyIdNominaPayslipsNewRoute
  '/companies/$companyId/notas-credito/$noteId/preview': typeof CompaniesCompanyIdNotasCreditoNoteIdPreviewRoute
  '/companies/$companyId/pos/ajustes/$adjustmentId': typeof CompaniesCompanyIdPosAjustesAdjustmentIdRoute
  '/companies/$companyId/pos/ajustes/new': typeof CompaniesCompanyIdPosAjustesNewRoute
  '/companies/$companyId/contabilidad/diario/': typeof CompaniesCompanyIdContabilidadDiarioIndexRoute
  '/companies/$companyId/contabilidad/mayor/': typeof CompaniesCompanyIdContabilidadMayorIndexRoute
  '/companies/$companyId/facturas/$invoiceId/': typeof CompaniesCompanyIdFacturasInvoiceIdIndexRoute
  '/companies/$companyId/inventario/conteos/': typeof CompaniesCompanyIdInventarioConteosIndexRoute
  '/companies/$companyId/inventario/movimientos/': typeof CompaniesCompanyIdInventarioMovimientosIndexRoute
  '/companies/$companyId/nomina/ajustes/': typeof CompaniesCompanyIdNominaAjustesIndexRoute
  '/companies/$companyId/nomina/definitivas/': typeof CompaniesCompanyIdNominaDefinitivasIndexRoute
  '/companies/$companyId/nomina/empleados/': typeof CompaniesCompanyIdNominaEmpleadosIndexRoute
  '/companies/$companyId/nomina/liquidaciones/': typeof CompaniesCompanyIdNominaLiquidacionesIndexRoute
  '/companies/$companyId/nomina/payslips/': typeof CompaniesCompanyIdNominaPayslipsIndexRoute
  '/companies/$companyId/notas-credito/$noteId/': typeof CompaniesCompanyIdNotasCreditoNoteIdIndexRoute
  '/companies/$companyId/pos/ajustes/': typeof CompaniesCompanyIdPosAjustesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/login'
    | '/onboarding'
    | '/profile'
    | '/auth/callback'
    | '/companies/$companyId'
    | '/companies/new'
    | '/settings/tokens'
    | '/teams/$teamId'
    | '/teams/accept'
    | '/companies/'
    | '/settings/'
    | '/subscription/'
    | '/teams/'
    | '/companies/$companyId/bancos'
    | '/companies/$companyId/edit'
    | '/invite/accept/$token'
    | '/invite/decline/$token'
    | '/companies/$companyId/'
    | '/companies/$companyId/cartera/$terceroId'
    | '/companies/$companyId/compras/$invoiceId'
    | '/companies/$companyId/compras/new'
    | '/companies/$companyId/contabilidad/cuentas'
    | '/companies/$companyId/contabilidad/saldos-iniciales'
    | '/companies/$companyId/documentos-soporte/$documentId'
    | '/companies/$companyId/documentos-soporte/new'
    | '/companies/$companyId/egresos/$voucherId'
    | '/companies/$companyId/egresos/new'
    | '/companies/$companyId/facturas/new'
    | '/companies/$companyId/impuestos/$eventId'
    | '/companies/$companyId/impuestos/configuracion'
    | '/companies/$companyId/inventario/bodegas'
    | '/companies/$companyId/inventario/reportes'
    | '/companies/$companyId/notas-credito/new'
    | '/companies/$companyId/notas-debito/$noteId'
    | '/companies/$companyId/notas-debito/new'
    | '/companies/$companyId/pos/$documentId'
    | '/companies/$companyId/pos/new'
    | '/companies/$companyId/productos/$productId'
    | '/companies/$companyId/productos/new'
    | '/companies/$companyId/recibidas/$receivedId'
    | '/companies/$companyId/recibidas/buzon'
    | '/companies/$companyId/recibos/$receiptId'
    | '/companies/$companyId/recibos/new'
    | '/companies/$companyId/reportes/balance-general'
    | '/companies/$companyId/reportes/estado-resultados'
    | '/companies/$companyId/reportes/iva'
    | '/companies/$companyId/reportes/retenciones'
    | '/companies/$companyId/terceros/$terceroId'
    | '/companies/$companyId/terceros/new'
    | '/companies/$companyId/archivos/'
    | '/companies/$companyId/cartera/'
    | '/companies/$companyId/compras/'
    | '/companies/$companyId/contabilidad/'
    | '/companies/$companyId/documentos-soporte/'
    | '/companies/$companyId/egresos/'
    | '/companies/$companyId/facturas/'
    | '/companies/$companyId/importaciones/'
    | '/companies/$companyId/impuestos/'
    | '/companies/$companyId/inventario/'
    | '/companies/$companyId/nomina/'
    | '/companies/$companyId/notas-credito/'
    | '/companies/$companyId/notas-debito/'
    | '/companies/$companyId/pos/'
    | '/companies/$companyId/productos/'
    | '/companies/$companyId/puc/'
    | '/companies/$companyId/recibidas/'
    | '/companies/$companyId/recibos/'
    | '/companies/$companyId/reportes/'
    | '/companies/$companyId/resoluciones/'
    | '/companies/$companyId/terceros/'
    | '/companies/$companyId/contabilidad/diario/$entryId'
    | '/companies/$companyId/contabilidad/diario/nuevo'
    | '/companies/$companyId/contabilidad/mayor/$accountCode'
    | '/companies/$companyId/facturas/$invoiceId/preview'
    | '/companies/$companyId/inventario/conteos/$countId'
    | '/companies/$companyId/inventario/movimientos/new'
    | '/companies/$companyId/inventario/traslados/new'
    | '/companies/$companyId/nomina/ajustes/$adjustmentId'
    | '/companies/$companyId/nomina/ajustes/new'
    | '/companies/$companyId/nomina/definitivas/$settlementId'
    | '/companies/$companyId/nomina/definitivas/new'
    | '/companies/$companyId/nomina/empleados/$employeeId'
    | '/companies/$companyId/nomina/empleados/new'
    | '/companies/$companyId/nomina/liquidaciones/$liquidationId'
    | '/companies/$companyId/nomina/liquidaciones/new'
    | '/companies/$companyId/nomina/payslips/$payslipId'
    | '/companies/$companyId/nomina/payslips/new'
    | '/companies/$companyId/notas-credito/$noteId/preview'
    | '/companies/$companyId/pos/ajustes/$adjustmentId'
    | '/companies/$companyId/pos/ajustes/new'
    | '/companies/$companyId/contabilidad/diario/'
    | '/companies/$companyId/contabilidad/mayor/'
    | '/companies/$companyId/facturas/$invoiceId/'
    | '/companies/$companyId/inventario/conteos/'
    | '/companies/$companyId/inventario/movimientos/'
    | '/companies/$companyId/nomina/ajustes/'
    | '/companies/$companyId/nomina/definitivas/'
    | '/companies/$companyId/nomina/empleados/'
    | '/companies/$companyId/nomina/liquidaciones/'
    | '/companies/$companyId/nomina/payslips/'
    | '/companies/$companyId/notas-credito/$noteId/'
    | '/companies/$companyId/pos/ajustes/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/login'
    | '/onboarding'
    | '/profile'
    | '/auth/callback'
    | '/companies/new'
    | '/settings/tokens'
    | '/teams/$teamId'
    | '/teams/accept'
    | '/companies'
    | '/settings'
    | '/subscription'
    | '/teams'
    | '/companies/$companyId/bancos'
    | '/companies/$companyId/edit'
    | '/invite/accept/$token'
    | '/invite/decline/$token'
    | '/companies/$companyId'
    | '/companies/$companyId/cartera/$terceroId'
    | '/companies/$companyId/compras/$invoiceId'
    | '/companies/$companyId/compras/new'
    | '/companies/$companyId/contabilidad/cuentas'
    | '/companies/$companyId/contabilidad/saldos-iniciales'
    | '/companies/$companyId/documentos-soporte/$documentId'
    | '/companies/$companyId/documentos-soporte/new'
    | '/companies/$companyId/egresos/$voucherId'
    | '/companies/$companyId/egresos/new'
    | '/companies/$companyId/facturas/new'
    | '/companies/$companyId/impuestos/$eventId'
    | '/companies/$companyId/impuestos/configuracion'
    | '/companies/$companyId/inventario/bodegas'
    | '/companies/$companyId/inventario/reportes'
    | '/companies/$companyId/notas-credito/new'
    | '/companies/$companyId/notas-debito/$noteId'
    | '/companies/$companyId/notas-debito/new'
    | '/companies/$companyId/pos/$documentId'
    | '/companies/$companyId/pos/new'
    | '/companies/$companyId/productos/$productId'
    | '/companies/$companyId/productos/new'
    | '/companies/$companyId/recibidas/$receivedId'
    | '/companies/$companyId/recibidas/buzon'
    | '/companies/$companyId/recibos/$receiptId'
    | '/companies/$companyId/recibos/new'
    | '/companies/$companyId/reportes/balance-general'
    | '/companies/$companyId/reportes/estado-resultados'
    | '/companies/$companyId/reportes/iva'
    | '/companies/$companyId/reportes/retenciones'
    | '/companies/$companyId/terceros/$terceroId'
    | '/companies/$companyId/terceros/new'
    | '/companies/$companyId/archivos'
    | '/companies/$companyId/cartera'
    | '/companies/$companyId/compras'
    | '/companies/$companyId/contabilidad'
    | '/companies/$companyId/documentos-soporte'
    | '/companies/$companyId/egresos'
    | '/companies/$companyId/facturas'
    | '/companies/$companyId/importaciones'
    | '/companies/$companyId/impuestos'
    | '/companies/$companyId/inventario'
    | '/companies/$companyId/nomina'
    | '/companies/$companyId/notas-credito'
    | '/companies/$companyId/notas-debito'
    | '/companies/$companyId/pos'
    | '/companies/$companyId/productos'
    | '/companies/$companyId/puc'
    | '/companies/$companyId/recibidas'
    | '/companies/$companyId/recibos'
    | '/companies/$companyId/reportes'
    | '/companies/$companyId/resoluciones'
    | '/companies/$companyId/terceros'
    | '/companies/$companyId/contabilidad/diario/$entryId'
    | '/companies/$companyId/contabilidad/diario/nuevo'
    | '/companies/$companyId/contabilidad/mayor/$accountCode'
    | '/companies/$companyId/facturas/$invoiceId/preview'
    | '/companies/$companyId/inventario/conteos/$countId'
    | '/companies/$companyId/inventario/movimientos/new'
    | '/companies/$companyId/inventario/traslados/new'
    | '/companies/$companyId/nomina/ajustes/$adjustmentId'
    | '/companies/$companyId/nomina/ajustes/new'
    | '/companies/$companyId/nomina/definitivas/$settlementId'
    | '/companies/$companyId/nomina/definitivas/new'
    | '/companies/$companyId/nomina/empleados/$employeeId'
    | '/companies/$companyId/nomina/empleados/new'
    | '/companies/$companyId/nomina/liquidaciones/$liquidationId'
    | '/companies/$companyId/nomina/liquidaciones/new'
    | '/companies/$companyId/nomina/payslips/$payslipId'
    | '/companies/$companyId/nomina/payslips/new'
    | '/companies/$companyId/notas-credito/$noteId/preview'
    | '/companies/$companyId/pos/ajustes/$adjustmentId'
    | '/companies/$companyId/pos/ajustes/new'
    | '/companies/$companyId/contabilidad/diario'
    | '/companies/$companyId/contabilidad/mayor'
    | '/companies/$companyId/facturas/$invoiceId'
    | '/companies/$companyId/inventario/conteos'
    | '/companies/$companyId/inventario/movimientos'
    | '/companies/$companyId/nomina/ajustes'
    | '/companies/$companyId/nomina/definitivas'
    | '/companies/$companyId/nomina/empleados'
    | '/companies/$companyId/nomina/liquidaciones'
    | '/companies/$companyId/nomina/payslips'
    | '/companies/$companyId/notas-credito/$noteId'
    | '/companies/$companyId/pos/ajustes'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/login'
    | '/onboarding'
    | '/profile'
    | '/auth/callback'
    | '/companies/$companyId'
    | '/companies/new'
    | '/settings/tokens'
    | '/teams/$teamId'
    | '/teams/accept'
    | '/companies/'
    | '/settings/'
    | '/subscription/'
    | '/teams/'
    | '/companies/$companyId/bancos'
    | '/companies/$companyId/edit'
    | '/invite/accept/$token'
    | '/invite/decline/$token'
    | '/companies/$companyId/'
    | '/companies/$companyId/cartera/$terceroId'
    | '/companies/$companyId/compras/$invoiceId'
    | '/companies/$companyId/compras/new'
    | '/companies/$companyId/contabilidad/cuentas'
    | '/companies/$companyId/contabilidad/saldos-iniciales'
    | '/companies/$companyId/documentos-soporte/$documentId'
    | '/companies/$companyId/documentos-soporte/new'
    | '/companies/$companyId/egresos/$voucherId'
    | '/companies/$companyId/egresos/new'
    | '/companies/$companyId/facturas/new'
    | '/companies/$companyId/impuestos/$eventId'
    | '/companies/$companyId/impuestos/configuracion'
    | '/companies/$companyId/inventario/bodegas'
    | '/companies/$companyId/inventario/reportes'
    | '/companies/$companyId/notas-credito/new'
    | '/companies/$companyId/notas-debito/$noteId'
    | '/companies/$companyId/notas-debito/new'
    | '/companies/$companyId/pos/$documentId'
    | '/companies/$companyId/pos/new'
    | '/companies/$companyId/productos/$productId'
    | '/companies/$companyId/productos/new'
    | '/companies/$companyId/recibidas/$receivedId'
    | '/companies/$companyId/recibidas/buzon'
    | '/companies/$companyId/recibos/$receiptId'
    | '/companies/$companyId/recibos/new'
    | '/companies/$companyId/reportes/balance-general'
    | '/companies/$companyId/reportes/estado-resultados'
    | '/companies/$companyId/reportes/iva'
    | '/companies/$companyId/reportes/retenciones'
    | '/companies/$companyId/terceros/$terceroId'
    | '/companies/$companyId/terceros/new'
    | '/companies/$companyId/archivos/'
    | '/companies/$companyId/cartera/'
    | '/companies/$companyId/compras/'
    | '/companies/$companyId/contabilidad/'
    | '/companies/$companyId/documentos-soporte/'
    | '/companies/$companyId/egresos/'
    | '/companies/$companyId/facturas/'
    | '/companies/$companyId/importaciones/'
    | '/companies/$companyId/impuestos/'
    | '/companies/$companyId/inventario/'
    | '/companies/$companyId/nomina/'
    | '/companies/$companyId/notas-credito/'
    | '/companies/$companyId/notas-debito/'
    | '/companies/$companyId/pos/'
    | '/companies/$companyId/productos/'
    | '/companies/$companyId/puc/'
    | '/companies/$companyId/recibidas/'
    | '/companies/$companyId/recibos/'
    | '/companies/$companyId/reportes/'
    | '/companies/$companyId/resoluciones/'
    | '/companies/$companyId/terceros/'
    | '/companies/$companyId/contabilidad/diario/$entryId'
    | '/companies/$companyId/contabilidad/diario/nuevo'
    | '/companies/$companyId/contabilidad/mayor/$accountCode'
    | '/companies/$companyId/facturas/$invoiceId/preview'
    | '/companies/$companyId/inventario/conteos/$countId'
    | '/companies/$companyId/inventario/movimientos/new'
    | '/companies/$companyId/inventario/traslados/new'
    | '/companies/$companyId/nomina/ajustes/$adjustmentId'
    | '/companies/$companyId/nomina/ajustes/new'
    | '/companies/$companyId/nomina/definitivas/$settlementId'
    | '/companies/$companyId/nomina/definitivas/new'
    | '/companies/$companyId/nomina/empleados/$employeeId'
    | '/companies/$companyId/nomina/empleados/new'
    | '/companies/$companyId/nomina/liquidaciones/$liquidationId'
    | '/companies/$companyId/nomina/liquidaciones/new'
    | '/companies/$companyId/nomina/payslips/$payslipId'
    | '/companies/$companyId/nomina/payslips/new'
    | '/companies/$companyId/notas-credito/$noteId/preview'
    | '/companies/$companyId/pos/ajustes/$adjustmentId'
    | '/companies/$companyId/pos/ajustes/new'
    | '/companies/$companyId/contabilidad/diario/'
    | '/companies/$companyId/contabilidad/mayor/'
    | '/companies/$companyId/facturas/$invoiceId/'
    | '/companies/$companyId/inventario/conteos/'
    | '/companies/$companyId/inventario/movimientos/'
    | '/companies/$companyId/nomina/ajustes/'
    | '/companies/$companyId/nomina/definitivas/'
    | '/companies/$companyId/nomina/empleados/'
    | '/companies/$companyId/nomina/liquidaciones/'
    | '/companies/$companyId/nomina/payslips/'
    | '/companies/$companyId/notas-credito/$noteId/'
    | '/companies/$companyId/pos/ajustes/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRoute
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  ProfileRoute: typeof ProfileRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  CompaniesCompanyIdRoute: typeof CompaniesCompanyIdRouteWithChildren
  CompaniesNewRoute: typeof CompaniesNewRoute
  SettingsTokensRoute: typeof SettingsTokensRoute
  TeamsTeamIdRoute: typeof TeamsTeamIdRoute
  TeamsAcceptRoute: typeof TeamsAcceptRoute
  CompaniesIndexRoute: typeof CompaniesIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  SubscriptionIndexRoute: typeof SubscriptionIndexRoute
  TeamsIndexRoute: typeof TeamsIndexRoute
  InviteAcceptTokenRoute: typeof InviteAcceptTokenRoute
  InviteDeclineTokenRoute: typeof InviteDeclineTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teams/': {
      id: '/teams/'
      path: '/teams'
      fullPath: '/teams/'
      preLoaderRoute: typeof TeamsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscription/': {
      id: '/subscription/'
      path: '/subscription'
      fullPath: '/subscription/'
      preLoaderRoute: typeof SubscriptionIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies/': {
      id: '/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof CompaniesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teams/accept': {
      id: '/teams/accept'
      path: '/teams/accept'
      fullPath: '/teams/accept'
      preLoaderRoute: typeof TeamsAcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teams/$teamId': {
      id: '/teams/$teamId'
      path: '/teams/$teamId'
      fullPath: '/teams/$teamId'
      preLoaderRoute: typeof TeamsTeamIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/tokens': {
      id: '/settings/tokens'
      path: '/settings/tokens'
      fullPath: '/settings/tokens'
      preLoaderRoute: typeof SettingsTokensRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies/new': {
      id: '/companies/new'
      path: '/companies/new'
      fullPath: '/companies/new'
      preLoaderRoute: typeof CompaniesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies/$companyId': {
      id: '/companies/$companyId'
      path: '/companies/$companyId'
      fullPath: '/companies/$companyId'
      preLoaderRoute: typeof CompaniesCompanyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies/$companyId/': {
      id: '/companies/$companyId/'
      path: '/'
      fullPath: '/companies/$companyId/'
      preLoaderRoute: typeof CompaniesCompanyIdIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/invite/decline/$token': {
      id: '/invite/decline/$token'
      path: '/invite/decline/$token'
      fullPath: '/invite/decline/$token'
      preLoaderRoute: typeof InviteDeclineTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/accept/$token': {
      id: '/invite/accept/$token'
      path: '/invite/accept/$token'
      fullPath: '/invite/accept/$token'
      preLoaderRoute: typeof InviteAcceptTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies/$companyId/edit': {
      id: '/companies/$companyId/edit'
      path: '/edit'
      fullPath: '/companies/$companyId/edit'
      preLoaderRoute: typeof CompaniesCompanyIdEditRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/bancos': {
      id: '/companies/$companyId/bancos'
      path: '/bancos'
      fullPath: '/companies/$companyId/bancos'
      preLoaderRoute: typeof CompaniesCompanyIdBancosRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/terceros/': {
      id: '/companies/$companyId/terceros/'
      path: '/terceros'
      fullPath: '/companies/$companyId/terceros/'
      preLoaderRoute: typeof CompaniesCompanyIdTercerosIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/resoluciones/': {
      id: '/companies/$companyId/resoluciones/'
      path: '/resoluciones'
      fullPath: '/companies/$companyId/resoluciones/'
      preLoaderRoute: typeof CompaniesCompanyIdResolucionesIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/reportes/': {
      id: '/companies/$companyId/reportes/'
      path: '/reportes'
      fullPath: '/companies/$companyId/reportes/'
      preLoaderRoute: typeof CompaniesCompanyIdReportesIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/recibos/': {
      id: '/companies/$companyId/recibos/'
      path: '/recibos'
      fullPath: '/companies/$companyId/recibos/'
      preLoaderRoute: typeof CompaniesCompanyIdRecibosIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/recibidas/': {
      id: '/companies/$companyId/recibidas/'
      path: '/recibidas'
      fullPath: '/companies/$companyId/recibidas/'
      preLoaderRoute: typeof CompaniesCompanyIdRecibidasIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/puc/': {
      id: '/companies/$companyId/puc/'
      path: '/puc'
      fullPath: '/companies/$companyId/puc/'
      preLoaderRoute: typeof CompaniesCompanyIdPucIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/productos/': {
      id: '/companies/$companyId/productos/'
      path: '/productos'
      fullPath: '/companies/$companyId/productos/'
      preLoaderRoute: typeof CompaniesCompanyIdProductosIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/pos/': {
      id: '/companies/$companyId/pos/'
      path: '/pos'
      fullPath: '/companies/$companyId/pos/'
      preLoaderRoute: typeof CompaniesCompanyIdPosIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/notas-debito/': {
      id: '/companies/$companyId/notas-debito/'
      path: '/notas-debito'
      fullPath: '/companies/$companyId/notas-debito/'
      preLoaderRoute: typeof CompaniesCompanyIdNotasDebitoIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/notas-credito/': {
      id: '/companies/$companyId/notas-credito/'
      path: '/notas-credito'
      fullPath: '/companies/$companyId/notas-credito/'
      preLoaderRoute: typeof CompaniesCompanyIdNotasCreditoIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/nomina/': {
      id: '/companies/$companyId/nomina/'
      path: '/nomina'
      fullPath: '/companies/$companyId/nomina/'
      preLoaderRoute: typeof CompaniesCompanyIdNominaIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/inventario/': {
      id: '/companies/$companyId/inventario/'
      path: '/inventario'
      fullPath: '/companies/$companyId/inventario/'
      preLoaderRoute: typeof CompaniesCompanyIdInventarioIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/impuestos/': {
      id: '/companies/$companyId/impuestos/'
      path: '/impuestos'
      fullPath: '/companies/$companyId/impuestos/'
      preLoaderRoute: typeof CompaniesCompanyIdImpuestosIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/importaciones/': {
      id: '/companies/$companyId/importaciones/'
      path: '/importaciones'
      fullPath: '/companies/$companyId/importaciones/'
      preLoaderRoute: typeof CompaniesCompanyIdImportacionesIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/facturas/': {
      id: '/companies/$companyId/facturas/'
      path: '/facturas'
      fullPath: '/companies/$companyId/facturas/'
      preLoaderRoute: typeof CompaniesCompanyIdFacturasIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/egresos/': {
      id: '/companies/$companyId/egresos/'
      path: '/egresos'
      fullPath: '/companies/$companyId/egresos/'
      preLoaderRoute: typeof CompaniesCompanyIdEgresosIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/documentos-soporte/': {
      id: '/companies/$companyId/documentos-soporte/'
      path: '/documentos-soporte'
      fullPath: '/companies/$companyId/documentos-soporte/'
      preLoaderRoute: typeof CompaniesCompanyIdDocumentosSoporteIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/contabilidad/': {
      id: '/companies/$companyId/contabilidad/'
      path: '/contabilidad'
      fullPath: '/companies/$companyId/contabilidad/'
      preLoaderRoute: typeof CompaniesCompanyIdContabilidadIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/compras/': {
      id: '/companies/$companyId/compras/'
      path: '/compras'
      fullPath: '/companies/$companyId/compras/'
      preLoaderRoute: typeof CompaniesCompanyIdComprasIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/cartera/': {
      id: '/companies/$companyId/cartera/'
      path: '/cartera'
      fullPath: '/companies/$companyId/cartera/'
      preLoaderRoute: typeof CompaniesCompanyIdCarteraIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/archivos/': {
      id: '/companies/$companyId/archivos/'
      path: '/archivos'
      fullPath: '/companies/$companyId/archivos/'
      preLoaderRoute: typeof CompaniesCompanyIdArchivosIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/terceros/new': {
      id: '/companies/$companyId/terceros/new'
      path: '/terceros/new'
      fullPath: '/companies/$companyId/terceros/new'
      preLoaderRoute: typeof CompaniesCompanyIdTercerosNewRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/terceros/$terceroId': {
      id: '/companies/$companyId/terceros/$terceroId'
      path: '/terceros/$terceroId'
      fullPath: '/companies/$companyId/terceros/$terceroId'
      preLoaderRoute: typeof CompaniesCompanyIdTercerosTerceroIdRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/reportes/retenciones': {
      id: '/companies/$companyId/reportes/retenciones'
      path: '/reportes/retenciones'
      fullPath: '/companies/$companyId/reportes/retenciones'
      preLoaderRoute: typeof CompaniesCompanyIdReportesRetencionesRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/reportes/iva': {
      id: '/companies/$companyId/reportes/iva'
      path: '/reportes/iva'
      fullPath: '/companies/$companyId/reportes/iva'
      preLoaderRoute: typeof CompaniesCompanyIdReportesIvaRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/reportes/estado-resultados': {
      id: '/companies/$companyId/reportes/estado-resultados'
      path: '/reportes/estado-resultados'
      fullPath: '/companies/$companyId/reportes/estado-resultados'
      preLoaderRoute: typeof CompaniesCompanyIdReportesEstadoResultadosRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/reportes/balance-general': {
      id: '/companies/$companyId/reportes/balance-general'
      path: '/reportes/balance-general'
      fullPath: '/companies/$companyId/reportes/balance-general'
      preLoaderRoute: typeof CompaniesCompanyIdReportesBalanceGeneralRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/recibos/new': {
      id: '/companies/$companyId/recibos/new'
      path: '/recibos/new'
      fullPath: '/companies/$companyId/recibos/new'
      preLoaderRoute: typeof CompaniesCompanyIdRecibosNewRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/recibos/$receiptId': {
      id: '/companies/$companyId/recibos/$receiptId'
      path: '/recibos/$receiptId'
      fullPath: '/companies/$companyId/recibos/$receiptId'
      preLoaderRoute: typeof CompaniesCompanyIdRecibosReceiptIdRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/recibidas/buzon': {
      id: '/companies/$companyId/recibidas/buzon'
      path: '/recibidas/buzon'
      fullPath: '/companies/$companyId/recibidas/buzon'
      preLoaderRoute: typeof CompaniesCompanyIdRecibidasBuzonRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/recibidas/$receivedId': {
      id: '/companies/$companyId/recibidas/$receivedId'
      path: '/recibidas/$receivedId'
      fullPath: '/companies/$companyId/recibidas/$receivedId'
      preLoaderRoute: typeof CompaniesCompanyIdRecibidasReceivedIdRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/productos/new': {
      id: '/companies/$companyId/productos/new'
      path: '/productos/new'
      fullPath: '/companies/$companyId/productos/new'
      preLoaderRoute: typeof CompaniesCompanyIdProductosNewRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/productos/$productId': {
      id: '/companies/$companyId/productos/$productId'
      path: '/productos/$productId'
      fullPath: '/companies/$companyId/productos/$productId'
      preLoaderRoute: typeof CompaniesCompanyIdProductosProductIdRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/pos/new': {
      id: '/companies/$companyId/pos/new'
      path: '/pos/new'
      fullPath: '/companies/$companyId/pos/new'
      preLoaderRoute: typeof CompaniesCompanyIdPosNewRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/pos/$documentId': {
      id: '/companies/$companyId/pos/$documentId'
      path: '/pos/$documentId'
      fullPath: '/companies/$companyId/pos/$documentId'
      preLoaderRoute: typeof CompaniesCompanyIdPosDocumentIdRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/notas-debito/new': {
      id: '/companies/$companyId/notas-debito/new'
      path: '/notas-debito/new'
      fullPath: '/companies/$companyId/notas-debito/new'
      preLoaderRoute: typeof CompaniesCompanyIdNotasDebitoNewRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/notas-debito/$noteId': {
      id: '/companies/$companyId/notas-debito/$noteId'
      path: '/notas-debito/$noteId'
      fullPath: '/companies/$companyId/notas-debito/$noteId'
      preLoaderRoute: typeof CompaniesCompanyIdNotasDebitoNoteIdRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/notas-credito/new': {
      id: '/companies/$companyId/notas-credito/new'
      path: '/notas-credito/new'
      fullPath: '/companies/$companyId/notas-credito/new'
      preLoaderRoute: typeof CompaniesCompanyIdNotasCreditoNewRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/inventario/reportes': {
      id: '/companies/$companyId/inventario/reportes'
      path: '/inventario/reportes'
      fullPath: '/companies/$companyId/inventario/reportes'
      preLoaderRoute: typeof CompaniesCompanyIdInventarioReportesRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/inventario/bodegas': {
      id: '/companies/$companyId/inventario/bodegas'
      path: '/inventario/bodegas'
      fullPath: '/companies/$companyId/inventario/bodegas'
      preLoaderRoute: typeof CompaniesCompanyIdInventarioBodegasRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/impuestos/configuracion': {
      id: '/companies/$companyId/impuestos/configuracion'
      path: '/impuestos/configuracion'
      fullPath: '/companies/$companyId/impuestos/configuracion'
      preLoaderRoute: typeof CompaniesCompanyIdImpuestosConfiguracionRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/impuestos/$eventId': {
      id: '/companies/$companyId/impuestos/$eventId'
      path: '/impuestos/$eventId'
      fullPath: '/companies/$companyId/impuestos/$eventId'
      preLoaderRoute: typeof CompaniesCompanyIdImpuestosEventIdRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/facturas/new': {
      id: '/companies/$companyId/facturas/new'
      path: '/facturas/new'
      fullPath: '/companies/$companyId/facturas/new'
      preLoaderRoute: typeof CompaniesCompanyIdFacturasNewRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/egresos/new': {
      id: '/companies/$companyId/egresos/new'
      path: '/egresos/new'
      fullPath: '/companies/$companyId/egresos/new'
      preLoaderRoute: typeof CompaniesCompanyIdEgresosNewRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/egresos/$voucherId': {
      id: '/companies/$companyId/egresos/$voucherId'
      path: '/egresos/$voucherId'
      fullPath: '/companies/$companyId/egresos/$voucherId'
      preLoaderRoute: typeof CompaniesCompanyIdEgresosVoucherIdRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/documentos-soporte/new': {
      id: '/companies/$companyId/documentos-soporte/new'
      path: '/documentos-soporte/new'
      fullPath: '/companies/$companyId/documentos-soporte/new'
      preLoaderRoute: typeof CompaniesCompanyIdDocumentosSoporteNewRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/documentos-soporte/$documentId': {
      id: '/companies/$companyId/documentos-soporte/$documentId'
      path: '/documentos-soporte/$documentId'
      fullPath: '/companies/$companyId/documentos-soporte/$documentId'
      preLoaderRoute: typeof CompaniesCompanyIdDocumentosSoporteDocumentIdRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/contabilidad/saldos-iniciales': {
      id: '/companies/$companyId/contabilidad/saldos-iniciales'
      path: '/contabilidad/saldos-iniciales'
      fullPath: '/companies/$companyId/contabilidad/saldos-iniciales'
      preLoaderRoute: typeof CompaniesCompanyIdContabilidadSaldosInicialesRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/contabilidad/cuentas': {
      id: '/companies/$companyId/contabilidad/cuentas'
      path: '/contabilidad/cuentas'
      fullPath: '/companies/$companyId/contabilidad/cuentas'
      preLoaderRoute: typeof CompaniesCompanyIdContabilidadCuentasRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/compras/new': {
      id: '/companies/$companyId/compras/new'
      path: '/compras/new'
      fullPath: '/companies/$companyId/compras/new'
      preLoaderRoute: typeof CompaniesCompanyIdComprasNewRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/compras/$invoiceId': {
      id: '/companies/$companyId/compras/$invoiceId'
      path: '/compras/$invoiceId'
      fullPath: '/companies/$companyId/compras/$invoiceId'
      preLoaderRoute: typeof CompaniesCompanyIdComprasInvoiceIdRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/cartera/$terceroId': {
      id: '/companies/$companyId/cartera/$terceroId'
      path: '/cartera/$terceroId'
      fullPath: '/companies/$companyId/cartera/$terceroId'
      preLoaderRoute: typeof CompaniesCompanyIdCarteraTerceroIdRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/pos/ajustes/': {
      id: '/companies/$companyId/pos/ajustes/'
      path: '/pos/ajustes'
      fullPath: '/companies/$companyId/pos/ajustes/'
      preLoaderRoute: typeof CompaniesCompanyIdPosAjustesIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/notas-credito/$noteId/': {
      id: '/companies/$companyId/notas-credito/$noteId/'
      path: '/notas-credito/$noteId'
      fullPath: '/companies/$companyId/notas-credito/$noteId/'
      preLoaderRoute: typeof CompaniesCompanyIdNotasCreditoNoteIdIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/nomina/payslips/': {
      id: '/companies/$companyId/nomina/payslips/'
      path: '/nomina/payslips'
      fullPath: '/companies/$companyId/nomina/payslips/'
      preLoaderRoute: typeof CompaniesCompanyIdNominaPayslipsIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/nomina/liquidaciones/': {
      id: '/companies/$companyId/nomina/liquidaciones/'
      path: '/nomina/liquidaciones'
      fullPath: '/companies/$companyId/nomina/liquidaciones/'
      preLoaderRoute: typeof CompaniesCompanyIdNominaLiquidacionesIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/nomina/empleados/': {
      id: '/companies/$companyId/nomina/empleados/'
      path: '/nomina/empleados'
      fullPath: '/companies/$companyId/nomina/empleados/'
      preLoaderRoute: typeof CompaniesCompanyIdNominaEmpleadosIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/nomina/definitivas/': {
      id: '/companies/$companyId/nomina/definitivas/'
      path: '/nomina/definitivas'
      fullPath: '/companies/$companyId/nomina/definitivas/'
      preLoaderRoute: typeof CompaniesCompanyIdNominaDefinitivasIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/nomina/ajustes/': {
      id: '/companies/$companyId/nomina/ajustes/'
      path: '/nomina/ajustes'
      fullPath: '/companies/$companyId/nomina/ajustes/'
      preLoaderRoute: typeof CompaniesCompanyIdNominaAjustesIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/inventario/movimientos/': {
      id: '/companies/$companyId/inventario/movimientos/'
      path: '/inventario/movimientos'
      fullPath: '/companies/$companyId/inventario/movimientos/'
      preLoaderRoute: typeof CompaniesCompanyIdInventarioMovimientosIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/inventario/conteos/': {
      id: '/companies/$companyId/inventario/conteos/'
      path: '/inventario/conteos'
      fullPath: '/companies/$companyId/inventario/conteos/'
      preLoaderRoute: typeof CompaniesCompanyIdInventarioConteosIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/facturas/$invoiceId/': {
      id: '/companies/$companyId/facturas/$invoiceId/'
      path: '/facturas/$invoiceId'
      fullPath: '/companies/$companyId/facturas/$invoiceId/'
      preLoaderRoute: typeof CompaniesCompanyIdFacturasInvoiceIdIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/contabilidad/mayor/': {
      id: '/companies/$companyId/contabilidad/mayor/'
      path: '/contabilidad/mayor'
      fullPath: '/companies/$companyId/contabilidad/mayor/'
      preLoaderRoute: typeof CompaniesCompanyIdContabilidadMayorIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/contabilidad/diario/': {
      id: '/companies/$companyId/contabilidad/diario/'
      path: '/contabilidad/diario'
      fullPath: '/companies/$companyId/contabilidad/diario/'
      preLoaderRoute: typeof CompaniesCompanyIdContabilidadDiarioIndexRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/pos/ajustes/new': {
      id: '/companies/$companyId/pos/ajustes/new'
      path: '/pos/ajustes/new'
      fullPath: '/companies/$companyId/pos/ajustes/new'
      preLoaderRoute: typeof CompaniesCompanyIdPosAjustesNewRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/pos/ajustes/$adjustmentId': {
      id: '/companies/$companyId/pos/ajustes/$adjustmentId'
      path: '/pos/ajustes/$adjustmentId'
      fullPath: '/companies/$companyId/pos/ajustes/$adjustmentId'
      preLoaderRoute: typeof CompaniesCompanyIdPosAjustesAdjustmentIdRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/notas-credito/$noteId/preview': {
      id: '/companies/$companyId/notas-credito/$noteId/preview'
      path: '/notas-credito/$noteId/preview'
      fullPath: '/companies/$companyId/notas-credito/$noteId/preview'
      preLoaderRoute: typeof CompaniesCompanyIdNotasCreditoNoteIdPreviewRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/nomina/payslips/new': {
      id: '/companies/$companyId/nomina/payslips/new'
      path: '/nomina/payslips/new'
      fullPath: '/companies/$companyId/nomina/payslips/new'
      preLoaderRoute: typeof CompaniesCompanyIdNominaPayslipsNewRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/nomina/payslips/$payslipId': {
      id: '/companies/$companyId/nomina/payslips/$payslipId'
      path: '/nomina/payslips/$payslipId'
      fullPath: '/companies/$companyId/nomina/payslips/$payslipId'
      preLoaderRoute: typeof CompaniesCompanyIdNominaPayslipsPayslipIdRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/nomina/liquidaciones/new': {
      id: '/companies/$companyId/nomina/liquidaciones/new'
      path: '/nomina/liquidaciones/new'
      fullPath: '/companies/$companyId/nomina/liquidaciones/new'
      preLoaderRoute: typeof CompaniesCompanyIdNominaLiquidacionesNewRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/nomina/liquidaciones/$liquidationId': {
      id: '/companies/$companyId/nomina/liquidaciones/$liquidationId'
      path: '/nomina/liquidaciones/$liquidationId'
      fullPath: '/companies/$companyId/nomina/liquidaciones/$liquidationId'
      preLoaderRoute: typeof CompaniesCompanyIdNominaLiquidacionesLiquidationIdRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/nomina/empleados/new': {
      id: '/companies/$companyId/nomina/empleados/new'
      path: '/nomina/empleados/new'
      fullPath: '/companies/$companyId/nomina/empleados/new'
      preLoaderRoute: typeof CompaniesCompanyIdNominaEmpleadosNewRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/nomina/empleados/$employeeId': {
      id: '/companies/$companyId/nomina/empleados/$employeeId'
      path: '/nomina/empleados/$employeeId'
      fullPath: '/companies/$companyId/nomina/empleados/$employeeId'
      preLoaderRoute: typeof CompaniesCompanyIdNominaEmpleadosEmployeeIdRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/nomina/definitivas/new': {
      id: '/companies/$companyId/nomina/definitivas/new'
      path: '/nomina/definitivas/new'
      fullPath: '/companies/$companyId/nomina/definitivas/new'
      preLoaderRoute: typeof CompaniesCompanyIdNominaDefinitivasNewRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/nomina/definitivas/$settlementId': {
      id: '/companies/$companyId/nomina/definitivas/$settlementId'
      path: '/nomina/definitivas/$settlementId'
      fullPath: '/companies/$companyId/nomina/definitivas/$settlementId'
      preLoaderRoute: typeof CompaniesCompanyIdNominaDefinitivasSettlementIdRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/nomina/ajustes/new': {
      id: '/companies/$companyId/nomina/ajustes/new'
      path: '/nomina/ajustes/new'
      fullPath: '/companies/$companyId/nomina/ajustes/new'
      preLoaderRoute: typeof CompaniesCompanyIdNominaAjustesNewRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/nomina/ajustes/$adjustmentId': {
      id: '/companies/$companyId/nomina/ajustes/$adjustmentId'
      path: '/nomina/ajustes/$adjustmentId'
      fullPath: '/companies/$companyId/nomina/ajustes/$adjustmentId'
      preLoaderRoute: typeof CompaniesCompanyIdNominaAjustesAdjustmentIdRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/inventario/traslados/new': {
      id: '/companies/$companyId/inventario/traslados/new'
      path: '/inventario/traslados/new'
      fullPath: '/companies/$companyId/inventario/traslados/new'
      preLoaderRoute: typeof CompaniesCompanyIdInventarioTrasladosNewRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/inventario/movimientos/new': {
      id: '/companies/$companyId/inventario/movimientos/new'
      path: '/inventario/movimientos/new'
      fullPath: '/companies/$companyId/inventario/movimientos/new'
      preLoaderRoute: typeof CompaniesCompanyIdInventarioMovimientosNewRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/inventario/conteos/$countId': {
      id: '/companies/$companyId/inventario/conteos/$countId'
      path: '/inventario/conteos/$countId'
      fullPath: '/companies/$companyId/inventario/conteos/$countId'
      preLoaderRoute: typeof CompaniesCompanyIdInventarioConteosCountIdRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/facturas/$invoiceId/preview': {
      id: '/companies/$companyId/facturas/$invoiceId/preview'
      path: '/facturas/$invoiceId/preview'
      fullPath: '/companies/$companyId/facturas/$invoiceId/preview'
      preLoaderRoute: typeof CompaniesCompanyIdFacturasInvoiceIdPreviewRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/contabilidad/mayor/$accountCode': {
      id: '/companies/$companyId/contabilidad/mayor/$accountCode'
      path: '/contabilidad/mayor/$accountCode'
      fullPath: '/companies/$companyId/contabilidad/mayor/$accountCode'
      preLoaderRoute: typeof CompaniesCompanyIdContabilidadMayorAccountCodeRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/contabilidad/diario/nuevo': {
      id: '/companies/$companyId/contabilidad/diario/nuevo'
      path: '/contabilidad/diario/nuevo'
      fullPath: '/companies/$companyId/contabilidad/diario/nuevo'
      preLoaderRoute: typeof CompaniesCompanyIdContabilidadDiarioNuevoRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
    '/companies/$companyId/contabilidad/diario/$entryId': {
      id: '/companies/$companyId/contabilidad/diario/$entryId'
      path: '/contabilidad/diario/$entryId'
      fullPath: '/companies/$companyId/contabilidad/diario/$entryId'
      preLoaderRoute: typeof CompaniesCompanyIdContabilidadDiarioEntryIdRouteImport
      parentRoute: typeof CompaniesCompanyIdRoute
    }
  }
}

interface CompaniesCompanyIdRouteChildren {
  CompaniesCompanyIdBancosRoute: typeof CompaniesCompanyIdBancosRoute
  CompaniesCompanyIdEditRoute: typeof CompaniesCompanyIdEditRoute
  CompaniesCompanyIdIndexRoute: typeof CompaniesCompanyIdIndexRoute
  CompaniesCompanyIdCarteraTerceroIdRoute: typeof CompaniesCompanyIdCarteraTerceroIdRoute
  CompaniesCompanyIdComprasInvoiceIdRoute: typeof CompaniesCompanyIdComprasInvoiceIdRoute
  CompaniesCompanyIdComprasNewRoute: typeof CompaniesCompanyIdComprasNewRoute
  CompaniesCompanyIdContabilidadCuentasRoute: typeof CompaniesCompanyIdContabilidadCuentasRoute
  CompaniesCompanyIdContabilidadSaldosInicialesRoute: typeof CompaniesCompanyIdContabilidadSaldosInicialesRoute
  CompaniesCompanyIdDocumentosSoporteDocumentIdRoute: typeof CompaniesCompanyIdDocumentosSoporteDocumentIdRoute
  CompaniesCompanyIdDocumentosSoporteNewRoute: typeof CompaniesCompanyIdDocumentosSoporteNewRoute
  CompaniesCompanyIdEgresosVoucherIdRoute: typeof CompaniesCompanyIdEgresosVoucherIdRoute
  CompaniesCompanyIdEgresosNewRoute: typeof CompaniesCompanyIdEgresosNewRoute
  CompaniesCompanyIdFacturasNewRoute: typeof CompaniesCompanyIdFacturasNewRoute
  CompaniesCompanyIdImpuestosEventIdRoute: typeof CompaniesCompanyIdImpuestosEventIdRoute
  CompaniesCompanyIdImpuestosConfiguracionRoute: typeof CompaniesCompanyIdImpuestosConfiguracionRoute
  CompaniesCompanyIdInventarioBodegasRoute: typeof CompaniesCompanyIdInventarioBodegasRoute
  CompaniesCompanyIdInventarioReportesRoute: typeof CompaniesCompanyIdInventarioReportesRoute
  CompaniesCompanyIdNotasCreditoNewRoute: typeof CompaniesCompanyIdNotasCreditoNewRoute
  CompaniesCompanyIdNotasDebitoNoteIdRoute: typeof CompaniesCompanyIdNotasDebitoNoteIdRoute
  CompaniesCompanyIdNotasDebitoNewRoute: typeof CompaniesCompanyIdNotasDebitoNewRoute
  CompaniesCompanyIdPosDocumentIdRoute: typeof CompaniesCompanyIdPosDocumentIdRoute
  CompaniesCompanyIdPosNewRoute: typeof CompaniesCompanyIdPosNewRoute
  CompaniesCompanyIdProductosProductIdRoute: typeof CompaniesCompanyIdProductosProductIdRoute
  CompaniesCompanyIdProductosNewRoute: typeof CompaniesCompanyIdProductosNewRoute
  CompaniesCompanyIdRecibidasReceivedIdRoute: typeof CompaniesCompanyIdRecibidasReceivedIdRoute
  CompaniesCompanyIdRecibidasBuzonRoute: typeof CompaniesCompanyIdRecibidasBuzonRoute
  CompaniesCompanyIdRecibosReceiptIdRoute: typeof CompaniesCompanyIdRecibosReceiptIdRoute
  CompaniesCompanyIdRecibosNewRoute: typeof CompaniesCompanyIdRecibosNewRoute
  CompaniesCompanyIdReportesBalanceGeneralRoute: typeof CompaniesCompanyIdReportesBalanceGeneralRoute
  CompaniesCompanyIdReportesEstadoResultadosRoute: typeof CompaniesCompanyIdReportesEstadoResultadosRoute
  CompaniesCompanyIdReportesIvaRoute: typeof CompaniesCompanyIdReportesIvaRoute
  CompaniesCompanyIdReportesRetencionesRoute: typeof CompaniesCompanyIdReportesRetencionesRoute
  CompaniesCompanyIdTercerosTerceroIdRoute: typeof CompaniesCompanyIdTercerosTerceroIdRoute
  CompaniesCompanyIdTercerosNewRoute: typeof CompaniesCompanyIdTercerosNewRoute
  CompaniesCompanyIdArchivosIndexRoute: typeof CompaniesCompanyIdArchivosIndexRoute
  CompaniesCompanyIdCarteraIndexRoute: typeof CompaniesCompanyIdCarteraIndexRoute
  CompaniesCompanyIdComprasIndexRoute: typeof CompaniesCompanyIdComprasIndexRoute
  CompaniesCompanyIdContabilidadIndexRoute: typeof CompaniesCompanyIdContabilidadIndexRoute
  CompaniesCompanyIdDocumentosSoporteIndexRoute: typeof CompaniesCompanyIdDocumentosSoporteIndexRoute
  CompaniesCompanyIdEgresosIndexRoute: typeof CompaniesCompanyIdEgresosIndexRoute
  CompaniesCompanyIdFacturasIndexRoute: typeof CompaniesCompanyIdFacturasIndexRoute
  CompaniesCompanyIdImportacionesIndexRoute: typeof CompaniesCompanyIdImportacionesIndexRoute
  CompaniesCompanyIdImpuestosIndexRoute: typeof CompaniesCompanyIdImpuestosIndexRoute
  CompaniesCompanyIdInventarioIndexRoute: typeof CompaniesCompanyIdInventarioIndexRoute
  CompaniesCompanyIdNominaIndexRoute: typeof CompaniesCompanyIdNominaIndexRoute
  CompaniesCompanyIdNotasCreditoIndexRoute: typeof CompaniesCompanyIdNotasCreditoIndexRoute
  CompaniesCompanyIdNotasDebitoIndexRoute: typeof CompaniesCompanyIdNotasDebitoIndexRoute
  CompaniesCompanyIdPosIndexRoute: typeof CompaniesCompanyIdPosIndexRoute
  CompaniesCompanyIdProductosIndexRoute: typeof CompaniesCompanyIdProductosIndexRoute
  CompaniesCompanyIdPucIndexRoute: typeof CompaniesCompanyIdPucIndexRoute
  CompaniesCompanyIdRecibidasIndexRoute: typeof CompaniesCompanyIdRecibidasIndexRoute
  CompaniesCompanyIdRecibosIndexRoute: typeof CompaniesCompanyIdRecibosIndexRoute
  CompaniesCompanyIdReportesIndexRoute: typeof CompaniesCompanyIdReportesIndexRoute
  CompaniesCompanyIdResolucionesIndexRoute: typeof CompaniesCompanyIdResolucionesIndexRoute
  CompaniesCompanyIdTercerosIndexRoute: typeof CompaniesCompanyIdTercerosIndexRoute
  CompaniesCompanyIdContabilidadDiarioEntryIdRoute: typeof CompaniesCompanyIdContabilidadDiarioEntryIdRoute
  CompaniesCompanyIdContabilidadDiarioNuevoRoute: typeof CompaniesCompanyIdContabilidadDiarioNuevoRoute
  CompaniesCompanyIdContabilidadMayorAccountCodeRoute: typeof CompaniesCompanyIdContabilidadMayorAccountCodeRoute
  CompaniesCompanyIdFacturasInvoiceIdPreviewRoute: typeof CompaniesCompanyIdFacturasInvoiceIdPreviewRoute
  CompaniesCompanyIdInventarioConteosCountIdRoute: typeof CompaniesCompanyIdInventarioConteosCountIdRoute
  CompaniesCompanyIdInventarioMovimientosNewRoute: typeof CompaniesCompanyIdInventarioMovimientosNewRoute
  CompaniesCompanyIdInventarioTrasladosNewRoute: typeof CompaniesCompanyIdInventarioTrasladosNewRoute
  CompaniesCompanyIdNominaAjustesAdjustmentIdRoute: typeof CompaniesCompanyIdNominaAjustesAdjustmentIdRoute
  CompaniesCompanyIdNominaAjustesNewRoute: typeof CompaniesCompanyIdNominaAjustesNewRoute
  CompaniesCompanyIdNominaDefinitivasSettlementIdRoute: typeof CompaniesCompanyIdNominaDefinitivasSettlementIdRoute
  CompaniesCompanyIdNominaDefinitivasNewRoute: typeof CompaniesCompanyIdNominaDefinitivasNewRoute
  CompaniesCompanyIdNominaEmpleadosEmployeeIdRoute: typeof CompaniesCompanyIdNominaEmpleadosEmployeeIdRoute
  CompaniesCompanyIdNominaEmpleadosNewRoute: typeof CompaniesCompanyIdNominaEmpleadosNewRoute
  CompaniesCompanyIdNominaLiquidacionesLiquidationIdRoute: typeof CompaniesCompanyIdNominaLiquidacionesLiquidationIdRoute
  CompaniesCompanyIdNominaLiquidacionesNewRoute: typeof CompaniesCompanyIdNominaLiquidacionesNewRoute
  CompaniesCompanyIdNominaPayslipsPayslipIdRoute: typeof CompaniesCompanyIdNominaPayslipsPayslipIdRoute
  CompaniesCompanyIdNominaPayslipsNewRoute: typeof CompaniesCompanyIdNominaPayslipsNewRoute
  CompaniesCompanyIdNotasCreditoNoteIdPreviewRoute: typeof CompaniesCompanyIdNotasCreditoNoteIdPreviewRoute
  CompaniesCompanyIdPosAjustesAdjustmentIdRoute: typeof CompaniesCompanyIdPosAjustesAdjustmentIdRoute
  CompaniesCompanyIdPosAjustesNewRoute: typeof CompaniesCompanyIdPosAjustesNewRoute
  CompaniesCompanyIdContabilidadDiarioIndexRoute: typeof CompaniesCompanyIdContabilidadDiarioIndexRoute
  CompaniesCompanyIdContabilidadMayorIndexRoute: typeof CompaniesCompanyIdContabilidadMayorIndexRoute
  CompaniesCompanyIdFacturasInvoiceIdIndexRoute: typeof CompaniesCompanyIdFacturasInvoiceIdIndexRoute
  CompaniesCompanyIdInventarioConteosIndexRoute: typeof CompaniesCompanyIdInventarioConteosIndexRoute
  CompaniesCompanyIdInventarioMovimientosIndexRoute: typeof CompaniesCompanyIdInventarioMovimientosIndexRoute
  CompaniesCompanyIdNominaAjustesIndexRoute: typeof CompaniesCompanyIdNominaAjustesIndexRoute
  CompaniesCompanyIdNominaDefinitivasIndexRoute: typeof CompaniesCompanyIdNominaDefinitivasIndexRoute
  CompaniesCompanyIdNominaEmpleadosIndexRoute: typeof CompaniesCompanyIdNominaEmpleadosIndexRoute
  CompaniesCompanyIdNominaLiquidacionesIndexRoute: typeof CompaniesCompanyIdNominaLiquidacionesIndexRoute
  CompaniesCompanyIdNominaPayslipsIndexRoute: typeof CompaniesCompanyIdNominaPayslipsIndexRoute
  CompaniesCompanyIdNotasCreditoNoteIdIndexRoute: typeof CompaniesCompanyIdNotasCreditoNoteIdIndexRoute
  CompaniesCompanyIdPosAjustesIndexRoute: typeof CompaniesCompanyIdPosAjustesIndexRoute
}

const CompaniesCompanyIdRouteChildren: CompaniesCompanyIdRouteChildren = {
  CompaniesCompanyIdBancosRoute: CompaniesCompanyIdBancosRoute,
  CompaniesCompanyIdEditRoute: CompaniesCompanyIdEditRoute,
  CompaniesCompanyIdIndexRoute: CompaniesCompanyIdIndexRoute,
  CompaniesCompanyIdCarteraTerceroIdRoute:
    CompaniesCompanyIdCarteraTerceroIdRoute,
  CompaniesCompanyIdComprasInvoiceIdRoute:
    CompaniesCompanyIdComprasInvoiceIdRoute,
  CompaniesCompanyIdComprasNewRoute: CompaniesCompanyIdComprasNewRoute,
  CompaniesCompanyIdContabilidadCuentasRoute:
    CompaniesCompanyIdContabilidadCuentasRoute,
  CompaniesCompanyIdContabilidadSaldosInicialesRoute:
    CompaniesCompanyIdContabilidadSaldosInicialesRoute,
  CompaniesCompanyIdDocumentosSoporteDocumentIdRoute:
    CompaniesCompanyIdDocumentosSoporteDocumentIdRoute,
  CompaniesCompanyIdDocumentosSoporteNewRoute:
    CompaniesCompanyIdDocumentosSoporteNewRoute,
  CompaniesCompanyIdEgresosVoucherIdRoute:
    CompaniesCompanyIdEgresosVoucherIdRoute,
  CompaniesCompanyIdEgresosNewRoute: CompaniesCompanyIdEgresosNewRoute,
  CompaniesCompanyIdFacturasNewRoute: CompaniesCompanyIdFacturasNewRoute,
  CompaniesCompanyIdImpuestosEventIdRoute:
    CompaniesCompanyIdImpuestosEventIdRoute,
  CompaniesCompanyIdImpuestosConfiguracionRoute:
    CompaniesCompanyIdImpuestosConfiguracionRoute,
  CompaniesCompanyIdInventarioBodegasRoute:
    CompaniesCompanyIdInventarioBodegasRoute,
  CompaniesCompanyIdInventarioReportesRoute:
    CompaniesCompanyIdInventarioReportesRoute,
  CompaniesCompanyIdNotasCreditoNewRoute:
    CompaniesCompanyIdNotasCreditoNewRoute,
  CompaniesCompanyIdNotasDebitoNoteIdRoute:
    CompaniesCompanyIdNotasDebitoNoteIdRoute,
  CompaniesCompanyIdNotasDebitoNewRoute: CompaniesCompanyIdNotasDebitoNewRoute,
  CompaniesCompanyIdPosDocumentIdRoute: CompaniesCompanyIdPosDocumentIdRoute,
  CompaniesCompanyIdPosNewRoute: CompaniesCompanyIdPosNewRoute,
  CompaniesCompanyIdProductosProductIdRoute:
    CompaniesCompanyIdProductosProductIdRoute,
  CompaniesCompanyIdProductosNewRoute: CompaniesCompanyIdProductosNewRoute,
  CompaniesCompanyIdRecibidasReceivedIdRoute:
    CompaniesCompanyIdRecibidasReceivedIdRoute,
  CompaniesCompanyIdRecibidasBuzonRoute: CompaniesCompanyIdRecibidasBuzonRoute,
  CompaniesCompanyIdRecibosReceiptIdRoute:
    CompaniesCompanyIdRecibosReceiptIdRoute,
  CompaniesCompanyIdRecibosNewRoute: CompaniesCompanyIdRecibosNewRoute,
  CompaniesCompanyIdReportesBalanceGeneralRoute:
    CompaniesCompanyIdReportesBalanceGeneralRoute,
  CompaniesCompanyIdReportesEstadoResultadosRoute:
    CompaniesCompanyIdReportesEstadoResultadosRoute,
  CompaniesCompanyIdReportesIvaRoute: CompaniesCompanyIdReportesIvaRoute,
  CompaniesCompanyIdReportesRetencionesRoute:
    CompaniesCompanyIdReportesRetencionesRoute,
  CompaniesCompanyIdTercerosTerceroIdRoute:
    CompaniesCompanyIdTercerosTerceroIdRoute,
  CompaniesCompanyIdTercerosNewRoute: CompaniesCompanyIdTercerosNewRoute,
  CompaniesCompanyIdArchivosIndexRoute: CompaniesCompanyIdArchivosIndexRoute,
  CompaniesCompanyIdCarteraIndexRoute: CompaniesCompanyIdCarteraIndexRoute,
  CompaniesCompanyIdComprasIndexRoute: CompaniesCompanyIdComprasIndexRoute,
  CompaniesCompanyIdContabilidadIndexRoute:
    CompaniesCompanyIdContabilidadIndexRoute,
  CompaniesCompanyIdDocumentosSoporteIndexRoute:
    CompaniesCompanyIdDocumentosSoporteIndexRoute,
  CompaniesCompanyIdEgresosIndexRoute: CompaniesCompanyIdEgresosIndexRoute,
  CompaniesCompanyIdFacturasIndexRoute: CompaniesCompanyIdFacturasIndexRoute,
  CompaniesCompanyIdImportacionesIndexRoute:
    CompaniesCompanyIdImportacionesIndexRoute,
  CompaniesCompanyIdImpuestosIndexRoute: CompaniesCompanyIdImpuestosIndexRoute,
  CompaniesCompanyIdInventarioIndexRoute:
    CompaniesCompanyIdInventarioIndexRoute,
  CompaniesCompanyIdNominaIndexRoute: CompaniesCompanyIdNominaIndexRoute,
  CompaniesCompanyIdNotasCreditoIndexRoute:
    CompaniesCompanyIdNotasCreditoIndexRoute,
  CompaniesCompanyIdNotasDebitoIndexRoute:
    CompaniesCompanyIdNotasDebitoIndexRoute,
  CompaniesCompanyIdPosIndexRoute: CompaniesCompanyIdPosIndexRoute,
  CompaniesCompanyIdProductosIndexRoute: CompaniesCompanyIdProductosIndexRoute,
  CompaniesCompanyIdPucIndexRoute: CompaniesCompanyIdPucIndexRoute,
  CompaniesCompanyIdRecibidasIndexRoute: CompaniesCompanyIdRecibidasIndexRoute,
  CompaniesCompanyIdRecibosIndexRoute: CompaniesCompanyIdRecibosIndexRoute,
  CompaniesCompanyIdReportesIndexRoute: CompaniesCompanyIdReportesIndexRoute,
  CompaniesCompanyIdResolucionesIndexRoute:
    CompaniesCompanyIdResolucionesIndexRoute,
  CompaniesCompanyIdTercerosIndexRoute: CompaniesCompanyIdTercerosIndexRoute,
  CompaniesCompanyIdContabilidadDiarioEntryIdRoute:
    CompaniesCompanyIdContabilidadDiarioEntryIdRoute,
  CompaniesCompanyIdContabilidadDiarioNuevoRoute:
    CompaniesCompanyIdContabilidadDiarioNuevoRoute,
  CompaniesCompanyIdContabilidadMayorAccountCodeRoute:
    CompaniesCompanyIdContabilidadMayorAccountCodeRoute,
  CompaniesCompanyIdFacturasInvoiceIdPreviewRoute:
    CompaniesCompanyIdFacturasInvoiceIdPreviewRoute,
  CompaniesCompanyIdInventarioConteosCountIdRoute:
    CompaniesCompanyIdInventarioConteosCountIdRoute,
  CompaniesCompanyIdInventarioMovimientosNewRoute:
    CompaniesCompanyIdInventarioMovimientosNewRoute,
  CompaniesCompanyIdInventarioTrasladosNewRoute:
    CompaniesCompanyIdInventarioTrasladosNewRoute,
  CompaniesCompanyIdNominaAjustesAdjustmentIdRoute:
    CompaniesCompanyIdNominaAjustesAdjustmentIdRoute,
  CompaniesCompanyIdNominaAjustesNewRoute:
    CompaniesCompanyIdNominaAjustesNewRoute,
  CompaniesCompanyIdNominaDefinitivasSettlementIdRoute:
    CompaniesCompanyIdNominaDefinitivasSettlementIdRoute,
  CompaniesCompanyIdNominaDefinitivasNewRoute:
    CompaniesCompanyIdNominaDefinitivasNewRoute,
  CompaniesCompanyIdNominaEmpleadosEmployeeIdRoute:
    CompaniesCompanyIdNominaEmpleadosEmployeeIdRoute,
  CompaniesCompanyIdNominaEmpleadosNewRoute:
    CompaniesCompanyIdNominaEmpleadosNewRoute,
  CompaniesCompanyIdNominaLiquidacionesLiquidationIdRoute:
    CompaniesCompanyIdNominaLiquidacionesLiquidationIdRoute,
  CompaniesCompanyIdNominaLiquidacionesNewRoute:
    CompaniesCompanyIdNominaLiquidacionesNewRoute,
  CompaniesCompanyIdNominaPayslipsPayslipIdRoute:
    CompaniesCompanyIdNominaPayslipsPayslipIdRoute,
  CompaniesCompanyIdNominaPayslipsNewRoute:
    CompaniesCompanyIdNominaPayslipsNewRoute,
  CompaniesCompanyIdNotasCreditoNoteIdPreviewRoute:
    CompaniesCompanyIdNotasCreditoNoteIdPreviewRoute,
  CompaniesCompanyIdPosAjustesAdjustmentIdRoute:
    CompaniesCompanyIdPosAjustesAdjustmentIdRoute,
  CompaniesCompanyIdPosAjustesNewRoute: CompaniesCompanyIdPosAjustesNewRoute,
  CompaniesCompanyIdContabilidadDiarioIndexRoute:
    CompaniesCompanyIdContabilidadDiarioIndexRoute,
  CompaniesCompanyIdContabilidadMayorIndexRoute:
    CompaniesCompanyIdContabilidadMayorIndexRoute,
  CompaniesCompanyIdFacturasInvoiceIdIndexRoute:
    CompaniesCompanyIdFacturasInvoiceIdIndexRoute,
  CompaniesCompanyIdInventarioConteosIndexRoute:
    CompaniesCompanyIdInventarioConteosIndexRoute,
  CompaniesCompanyIdInventarioMovimientosIndexRoute:
    CompaniesCompanyIdInventarioMovimientosIndexRoute,
  CompaniesCompanyIdNominaAjustesIndexRoute:
    CompaniesCompanyIdNominaAjustesIndexRoute,
  CompaniesCompanyIdNominaDefinitivasIndexRoute:
    CompaniesCompanyIdNominaDefinitivasIndexRoute,
  CompaniesCompanyIdNominaEmpleadosIndexRoute:
    CompaniesCompanyIdNominaEmpleadosIndexRoute,
  CompaniesCompanyIdNominaLiquidacionesIndexRoute:
    CompaniesCompanyIdNominaLiquidacionesIndexRoute,
  CompaniesCompanyIdNominaPayslipsIndexRoute:
    CompaniesCompanyIdNominaPayslipsIndexRoute,
  CompaniesCompanyIdNotasCreditoNoteIdIndexRoute:
    CompaniesCompanyIdNotasCreditoNoteIdIndexRoute,
  CompaniesCompanyIdPosAjustesIndexRoute:
    CompaniesCompanyIdPosAjustesIndexRoute,
}

const CompaniesCompanyIdRouteWithChildren =
  CompaniesCompanyIdRoute._addFileChildren(CompaniesCompanyIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  ProfileRoute: ProfileRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  CompaniesCompanyIdRoute: CompaniesCompanyIdRouteWithChildren,
  CompaniesNewRoute: CompaniesNewRoute,
  SettingsTokensRoute: SettingsTokensRoute,
  TeamsTeamIdRoute: TeamsTeamIdRoute,
  TeamsAcceptRoute: TeamsAcceptRoute,
  CompaniesIndexRoute: CompaniesIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  SubscriptionIndexRoute: SubscriptionIndexRoute,
  TeamsIndexRoute: TeamsIndexRoute,
  InviteAcceptTokenRoute: InviteAcceptTokenRoute,
  InviteDeclineTokenRoute: InviteDeclineTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
